import {Injectable} from '@angular/core';
import {FascicoloFull} from "../../../common/models/fascicolo/fascicolo-full";
import {RowSezione} from "../../../common/models/fascicolo/row-sezione";
import {VoceSezione} from "../../../common/models/fascicolo/voce-sezione";
import {FormAmiantoGiudizialeComponent} from "../form-amianto-giudiziale/form-amianto-giudiziale.component";
import {
  FormAmiantoGiudizialeViewComponent
} from "../form-amianto-giudiziale/view/form-amianto-giudiziale-view.component";
import {FormAmiantoComponent} from "../form-amianto/form-amianto.component";
import {FormAmiantoViewComponent} from "../form-amianto/view/form-amianto-view.component";
import {FormArbitratoComponent} from "../form-arbitrato/form-arbitrato.component";
import {FormArbitratoViewComponent} from "../form-arbitrato/view/form-arbitrato-view.component";
import {FormAzioneMonitoriaComponent} from "../form-azione-monitoria/form-azione-monitoria.component";
import {FormAzioneMonitoriaViewComponent} from "../form-azione-monitoria/view/form-azione-monitoria-view.component";
import {FormAzioneRevocatoriaComponent} from "../form-azione-revocatoria/form-azione-revocatoria.component";
import {
  FormAzioneRevocatoriaViewComponent
} from "../form-azione-revocatoria/view/form-azione-revocatoria-view.component";
import {FormCautelareComponent} from "../form-cautelare/form-cautelare.component";
import {FormCautelareViewComponent} from "../form-cautelare/view/form-cautelare-view.component";
import {FormCoterziComponent} from "../form-coterzi/form-coterzi.component";
import {FormCoterziViewComponent} from "../form-coterzi/view/form-coterzi-view.component";
import {FormEsecuzioneComponent} from "../form-esecuzione/form-esecuzione.component";
import {FormEsecuzioneViewComponent} from "../form-esecuzione/view/form-esecuzione-view.component";
import {FormImmobiliareComponent} from "../form-immobiliare/form-immobiliare.component";
import {FormImmobiliareViewComponent} from "../form-immobiliare/view/form-immobiliare-view.component";
import {FormMediazioneComponent} from "../form-mediazione/form-mediazione.component";
import {FormMediazioneViewComponent} from "../form-mediazione/view/form-mediazione-view.component";
import {FormMobiliareComponent} from "../form-mobiliare/form-mobiliare.component";
import {FormMobiliareViewComponent} from "../form-mobiliare/view/form-mobiliare-view.component";
import {
  FormNegoziazioneAssistitaComponent
} from "../form-negoziazione-assistita/form-negoziazione-assistita.component";
import {
  FormNegoziazioneAssistitaViewComponent
} from "../form-negoziazione-assistita/view/form-negoziazione-assistita-view.component";
import {
  FormOpposizioneAttiEsecutiviComponent
} from "../form-opposizione-atti-esecutivi/form-opposizione-atti-esecutivi.component";
import {
  FormOpposizioneAttiEsecutiviViewComponent
} from "../form-opposizione-atti-esecutivi/view/form-opposizione-atti-esecutivi-view.component";
import {
  FormOpposizioneDecretoIngiuntivoComponent
} from "../form-opposizione-decreto-ingiuntivo/form-opposizione-decreto-ingiuntivo.component";
import {
  FormOpposizioneDecretoIngiuntivoViewComponent
} from "../form-opposizione-decreto-ingiuntivo/view/form-opposizione-decreto-ingiuntivo-view.component";
import {
  FormOpposizioneEsecuzioneComponent
} from "../form-opposizione-esecuzione/form-opposizione-esecuzione.component";
import {
  FormOpposizioneEsecuzioneViewComponent
} from "../form-opposizione-esecuzione/view/form-opposizione-esecuzione-view.component";
import {FormOpposizionePrecettoComponent} from "../form-opposizione-precetto/form-opposizione-precetto.component";
import {
  FormOpposizionePrecettoViewComponent
} from "../form-opposizione-precetto/view/form-opposizione-precetto-view.component";
import {FormOrdinarioComponent} from "../form-ordinario/form-ordinario.component";
import {FormOrdinarioViewComponent} from "../form-ordinario/view/form-ordinario-view.component";
import {FormPrecettoComponent} from "../form-precetto/form-precetto.component";
import {FormPrecettoViewComponent} from "../form-precetto/view/form-precetto-view.component";
import {
  FormRecuperoCreditiStragiudizialeComponent
} from "../form-recupero-crediti-stragiudiziale/form-recupero-crediti-stragiudiziale.component";
import {
  FormRecuperoCreditiStragiudizialeViewComponent
} from "../form-recupero-crediti-stragiudiziale/view/form-recupero-crediti-stragiudiziale-view.component";
import {FormRicorsoLavoroComponent} from "../form-ricorso-lavoro/form-ricorso-lavoro.component";
import {FormRicorsoLavoroViewComponent} from "../form-ricorso-lavoro/view/form-ricorso-lavoro-view.component";
import {FormRicorsoAmministrativoComponent} from '../form-ricorso/form-ricorso.component';
import {FormRicorsoAmministrativoViewComponent} from '../form-ricorso/view/form-ricorso-view.component';
import {FormSinistroSanitarioComponent} from '../form-sinistro-sanitario/form-sinistro-sanitario.component';
import {
  FormSinistroSanitarioViewComponent
} from '../form-sinistro-sanitario/view/form-sinistro-sanitario-view.component';
import {FormSommarioUrgenzaComponent} from "../form-sommario-urgenza/form-sommario-urgenza.component";
import {FormSommarioUrgenzaViewComponent} from "../form-sommario-urgenza/view/form-sommario-urgenza-view.component";
import {FormSpecialeComponent} from "../form-speciale/form-speciale.component";
import {FormSpecialeViewComponent} from "../form-speciale/view/form-speciale-view.component";
import {FascicoloAmiantoGiudiziale} from "../models/amianto-giudiziale/fascicolo-amianto-giudiziale";
import {FascicoloAmianto} from "../models/amianto/fascicolo-amianto";
import {FascicoloArbitrato} from "../models/arbitrato/fascicolo-arbitrato";
import {FascicoloAzioneMonitoria} from "../models/azione-monitoria/fascicolo-azione-monitoria";
import {FascicoloAzioneRevocatoria} from "../models/azione-revocatoria/fascicolo-azione-revocatoria";
import {FascicoloCautelare} from "../models/cautelare/fascicolo-cautelare";
import {FascicoloCoTerzi} from "../models/coterzi/fascicolo-coterzi";
import {FascicoloEsecuzione} from "../models/esecuzione/fascicolo-esecuzione";
import {FascicoloImmobiliare} from "../models/immobiliare/fascicolo-immobiliare";
import {FascicoloMediazione} from "../models/mediazione/fascicolo-mediazione";
import {FascicoloMobiliare} from "../models/mobiliare/fascicolo-mobiliare";
import {FascicoloNegoziazioneAssistita} from "../models/negoziazione-assistita/fascicolo-negoziazione-assistita";
import {
  FascicoloOpposizioneAttiEsecutivi
} from "../models/opposizione-atti-esecutivi/fascicolo-opposizione-atti-esecutivi";
import {
  FascicoloOpposizioneDecretoIngiuntivo
} from "../models/opposizione-decreto-ingiuntivo/fascicolo-opposizione-decreto-ingiuntivo";
import {FascicoloOpposizioneEsecuzione} from "../models/opposizione-esecuzione/fascicolo-opposizione-esecuzione";
import {FascicoloOpposizionePrecetto} from "../models/opposizione-precetto/fascicolo-opposizione-precetto";
import {FascicoloOrdinario} from "../models/ordinario/fascicolo-ordinario";
import {FascicoloPrecetto} from "../models/precetto/fascicolo-precetto";
import {
  FascicoloRecuperoCreditiStragiudiziale
} from "../models/recupero-crediti-stragiudiziale/fascicolo-recuperocreditistragiudiziale";
import {FascicoloRicorsoAmministrativo} from '../models/ricorso-amministrativo/fascicolo-ricorso-amministrativo';
import {FascicoloRicorsoLavoro} from "../models/ricorso-lavoro/fascicolo-ricorso-lavoro";
import {FascicoloSinistroSanitario} from '../models/sinistro-sanitario/fascicolo-sinistrosanitario';
import {FascicoloSommarioUrgenza} from "../models/sommario-urgenza/fascicolo-sommariourgenza";
import {FascicoloSpeciale} from "../models/speciale/fascicolo-speciale";
import {FascicoloGenerico} from '../models/generico/fascicolo-generico';
import {FormGenericoViewComponent} from '../form-generico/view/form-generico-view.component';
import {FormGenericoComponent} from '../form-generico/form-generico.component';

@Injectable({
  providedIn: 'root'
})

export class FascicoloService {

  constructor() {
  }

  getFascicolo(genericFascicolo): any {
    let fascicolo;
    switch (genericFascicolo) {
      case 'ordinario': {
        fascicolo = new FascicoloOrdinario();
        break;
      }
      case 'opposizionedecretoingiuntivo': {
        fascicolo = new FascicoloOpposizioneDecretoIngiuntivo();
        break;
      }
      case 'opposizioneattiesecutivi': {
        fascicolo = new FascicoloOpposizioneAttiEsecutivi();
        break;
      }
      case 'opposizioneprecetto': {
        fascicolo = new FascicoloOpposizionePrecetto();
        break;
      }
      case 'opposizioneesecuzione': {
        fascicolo = new FascicoloOpposizioneEsecuzione();
        break;
      }
      case 'opposizione': {
        fascicolo = new FascicoloOpposizioneDecretoIngiuntivo();
      }
      case 'cautelare': {
        fascicolo = new FascicoloCautelare();
        break;
      }
      case 'speciale': {
        fascicolo = new FascicoloSpeciale();
        break;
      }
      case 'sommariourgenza': {
        fascicolo = new FascicoloSommarioUrgenza();
        break;
      }
      case 'esecuzioneimmobiliare': {
        fascicolo = new FascicoloImmobiliare();
        break;
      }
      case 'esecuzionemobiliare': {
        fascicolo = new FascicoloMobiliare();
        break;
      }
      case 'esecuzionepressoterzi': {
        fascicolo = new FascicoloCoTerzi();
        break;
      }
      case 'azionemonitoria': {
        fascicolo = new FascicoloAzioneMonitoria();
        break;
      }
      case 'precetto': {
        fascicolo = new FascicoloPrecetto();
        break;
      }
      case 'arbitrato': {
        fascicolo = new FascicoloArbitrato();
        break;
      }
      case 'mediazione': {
        fascicolo = new FascicoloMediazione();
        break;
      }
      case 'recuperocreditistragiudiziale': {
        fascicolo = new FascicoloRecuperoCreditiStragiudiziale();
        break;
      }
      case 'negoziazione': {
        fascicolo = new FascicoloNegoziazioneAssistita();
        break;
      }
      case 'sinistrosanitario': {
        fascicolo = new FascicoloSinistroSanitario();
        break;
      }
      case 'amianto': {
        fascicolo = new FascicoloAmianto();
        break;
      }
      case 'amiantogiudiziale': {
        fascicolo = new FascicoloAmiantoGiudiziale();
        break;
      }
      case 'ricorso':
      case 'ricorsolavoro': {
        fascicolo = new FascicoloRicorsoLavoro();
        break;
      }
      case 'azionerevocatoria': {
        fascicolo = new FascicoloAzioneRevocatoria();
        break;
      }
      case 'esecuzione': {
        fascicolo = new FascicoloEsecuzione();
        break;
      }
      case 'ricorsoamministrativo':
      case 'ricorsotar': {
        fascicolo = new FascicoloRicorsoAmministrativo();
        break;
      }
      case 'genericogiudiziale': {
        fascicolo = new FascicoloGenerico();
        break;
      }
    }
    return fascicolo;
  }

  getComponentFromFormTenant(idFormTenant, view = false) {
    let component;
    switch (idFormTenant) {
      case 'CivOrd_PRD': {
        component = view ? FormOrdinarioViewComponent : FormOrdinarioComponent; // "ORDINARIO";
        break;
      }
      case 'CivOdi_PRD': {
        component = view ? FormOpposizioneDecretoIngiuntivoViewComponent : FormOpposizioneDecretoIngiuntivoComponent; // "OPPOSIZIONE AL DECRETO INGIUNTIVO";
        break;
      }
      case 'CivOpp_PRD': {
        component = view ? FormOpposizioneDecretoIngiuntivoViewComponent : FormOpposizioneDecretoIngiuntivoComponent; // "OPPOSIZIONE AL DECRETO INGIUNTIVO";
        break;
      }
      case 'CivOae_PRD': {
        component = view ? FormOpposizioneAttiEsecutiviViewComponent : FormOpposizioneAttiEsecutiviComponent; // "OPPOSIZIONE AGLI ATTI ESECUTIVI";
        break;
      }
      case 'CivOpr_PRD': {
        component = view ? FormOpposizionePrecettoViewComponent : FormOpposizionePrecettoComponent; // "OPPOSIZIONE A PRECETTO";
        break;
      }
      case 'CivOes_PRD': {
        component = view ? FormOpposizioneEsecuzioneViewComponent : FormOpposizioneEsecuzioneComponent; // "OPPOSIZIONE ALL'ESECUZIONE";
        break;
      }
      case 'CivCau_PRD': {
        component = view ? FormCautelareViewComponent : FormCautelareComponent; // "CAUTELARE";
        break;
      }
      case 'CivSpe_PRD': {
        component = view ? FormSpecialeViewComponent : FormSpecialeComponent; // "SPECIALE";
        break;
      }
      case 'CivSom_PRD': {
        component = view ? FormSommarioUrgenzaViewComponent : FormSommarioUrgenzaComponent; // "SOMMARIO D'URGENZA";
        break;
      }
      case 'CivEim_PRD': {
        component = view ? FormImmobiliareViewComponent : FormImmobiliareComponent; // "ESECUZIONE IMMOBILIARE";
        break;
      }
      case 'CivEmo_PRD': {
        component = view ? FormMobiliareViewComponent : FormMobiliareComponent; // "ESECUZIONE MOBILIARE";
        break;
      }
      case 'CivEpt_PRD': {
        component = view ? FormCoterziViewComponent : FormCoterziComponent; // "ESECUZIONE C/O TERZI";
        break;
      }
      case 'CivAzi_PRD': {
        component = view ? FormAzioneMonitoriaViewComponent : FormAzioneMonitoriaComponent; // "AZIONE MONITORIA";
        break;
      }
      case 'CivPre_PRD': {
        component = view ? FormPrecettoViewComponent : FormPrecettoComponent; // "PRECETTO";
        break;
      }
      case 'CivNeg_PRD': {
        component = view ? FormNegoziazioneAssistitaViewComponent : FormNegoziazioneAssistitaComponent; // "NEGOZIAZIONE ASSISTITA";
        break;
      }
      case 'CivArb_PRD': {
        component = view ? FormArbitratoViewComponent : FormArbitratoComponent; // "ARBRITATO";
        break;
      }
      case 'CivMed_PRD': {
        component = view ? FormMediazioneViewComponent : FormMediazioneComponent; // "MEDIAZIONE";
        break;
      }
      case 'CivRec_PRD': {
        component = view ? FormRecuperoCreditiStragiudizialeViewComponent : FormRecuperoCreditiStragiudizialeComponent; // "RECUPERO CREDITI STRAGIUDIZIALE";
        break;
      }
      case 'CivSan_PRD': {
        component = view ? FormSinistroSanitarioViewComponent : FormSinistroSanitarioComponent; // "SINISTRO SANITARIO";
        break;
      }
      case 'CivAmi_PRD': {
        component = view ? FormAmiantoViewComponent : FormAmiantoComponent;
        break;
      }
      case 'CivAmg_PRD': {
        component = view ? FormAmiantoGiudizialeViewComponent : FormAmiantoGiudizialeComponent;
        break;
      }
      case 'CivRla_PRD': {
        component = view ? FormRicorsoLavoroViewComponent : FormRicorsoLavoroComponent;
        break;
      }
      case 'CivArv_PRD': {
        component = view ? FormAzioneRevocatoriaViewComponent : FormAzioneRevocatoriaComponent;
        break;
      }
      case 'CivEse_PRD': {
        component = view ? FormEsecuzioneViewComponent : FormEsecuzioneComponent;
        break;
      }
      case 'CivRam_PRD': {
        component = view ? FormRicorsoAmministrativoViewComponent : FormRicorsoAmministrativoComponent;
        break;
      }
      case 'CivGen_PRD': {
        component = view ? FormGenericoViewComponent : FormGenericoComponent; // "GENERICO";
        break;
      }
    }
    return component;
  }

  getMappaCopertinaFascicolo(genericFascicolo: string, fascicolo: FascicoloFull, viewComponentDynamic: string, assegnatario?: string): RowSezione[] {
    // todo: ottimizzare funzione + gestire viewComponentDynamic;
    let esiti = this.getEsitiFromCopertina(fascicolo);
    let udienzeEsiti = this.getUdienzeEsitiFromCopertina(fascicolo);
    switch (genericFascicolo) {
      case 'ordinario':
      case 'genericogiudiziale':
      case 'azionerevocatoria': {
        return [new RowSezione(null, [
          new VoceSezione(3, 'text', 'Posizione', fascicolo.copertina.campi.identificativoFascicolo),
          new VoceSezione(3, 'text', 'Vecchia posizione', fascicolo.vecchiaPosizione),
          new VoceSezione(3, 'text', 'Tipo Fascicolo', fascicolo.copertina.campi.tipo),
          new VoceSezione(3, 'text', 'Stato', fascicolo.copertina.campi.stato)
        ]),
          new RowSezione(null, [
            new VoceSezione(3, 'text', 'Natura', fascicolo.copertina.campi.natura),
            new VoceSezione(3, 'text', 'Parti', fascicolo.copertina.campi.parti),
            new VoceSezione(3, 'text', 'Assegnatario', assegnatario),
            new VoceSezione(3, 'text', 'Legale di controparte', fascicolo.copertina.campi.legaliControparti)
          ]),
          new RowSezione(null, [
            new VoceSezione(12, 'text', 'Fondo rischi SI/NO', true === fascicolo.copertina.campi.fondoRischi ? 'Si' : 'No'),
          ]),
          new RowSezione('Dati Giudiziari', [
            new VoceSezione(4, 'text', 'Autorit&agrave; giudiziaria', (fascicolo.copertina.campi.autoritaGiudiziaria ? fascicolo.copertina.campi.autoritaGiudiziaria : '')),
            new VoceSezione(4, 'text', 'Sede', fascicolo.copertina.campi.sedeAutoritaGiudiziaria),
            new VoceSezione(4, 'text', 'Grado', (fascicolo.copertina.campi.grado ? fascicolo.copertina.campi.grado : '')),
            new VoceSezione(6, 'text', 'Numero/anno ruolo', (fascicolo.copertina.campi.numeroRuolo ? fascicolo.copertina.campi.numeroRuolo : '') + (fascicolo.copertina.campi.numeroRuolo && fascicolo.copertina.campi.annoRuolo ? '/' : '') + (fascicolo.copertina.campi.annoRuolo ? fascicolo.copertina.campi.annoRuolo : '')),
            new VoceSezione(6, 'text', 'Sezione', fascicolo.copertina.campi.sezione)
          ]),
          new RowSezione(null, [
            new VoceSezione(12, 'textarea', 'Descrizione oggetto', fascicolo.descrizioneOggetto),
          ]),
          new RowSezione(null, [
            new VoceSezione(4, 'date', 'Data apertura fascicolo', fascicolo.copertina.campi.dataInizioFascicolo),
            new VoceSezione(4, 'date', 'Data notifica', fascicolo.dataNotifica),
            new VoceSezione(4, 'date', 'Data prima comparizione', fascicolo.dataPrimaComparizione)
          ]),
          new RowSezione(null, [
            new VoceSezione(4, 'text', 'Costituzione SI/NO', true === fascicolo.flagCostituzione ? 'Si' : 'No'),
            new VoceSezione(4, 'text', 'Motivazione', fascicolo.motivazione ? fascicolo.motivazione.label : ''),
            new VoceSezione(4, 'date', 'Data costituzione', fascicolo.dataCostituzione)
          ]),
          new RowSezione(((fascicolo.copertina.campi.capofila || fascicolo.copertina.campi.riunito) ? 'Riunione dei giudizi' : ''), (fascicolo.copertina.campi.capofila || fascicolo.copertina.campi.riunito) ? [
            new VoceSezione(4, 'text', fascicolo.copertina.campi.capofila ? 'Capofila' : 'Riunito', 'Si'),
            new VoceSezione(4, 'date', 'Data riunione giudizio', fascicolo.copertina.campi.dataRiunioneGiudizio),
            new VoceSezione(4, 'text', 'Motivo riunione giudizio', fascicolo.copertina.campi.motivoRiunioneGiudizio)
          ] : [new VoceSezione(12, '', '', '')]),
          esiti.length > 0 ? new RowSezione("Esiti",esiti) : new RowSezione(null, null),
          udienzeEsiti.length > 0 ? new RowSezione("Udienze",udienzeEsiti) : new RowSezione(null,null),
          new RowSezione('Prossima udienza', [
            // new VoceSezione(4, 'date', 'Ultima udienza', fascicolo.copertina.campi.ultimaUdienza),
            new VoceSezione(6, 'text', 'Adempimento', fascicolo.copertina.campi.prossimaUdienzaTipoAdempimento),
            new VoceSezione(6, 'date', 'Prossima udienza', fascicolo.copertina.campi.prossimaUdienza),
            // new VoceSezione(4, 'date', 'Prossima scadenza', fascicolo.copertina.campi.prossimaScadenza)
          ]),
          new RowSezione('Competenze ', [
            new VoceSezione(12, 'text', 'Gruppi competenti', fascicolo.copertina.campi.competenza)
          ]),
        ];
        break;
      }
      case 'opposizionedecretoingiuntivo': {
        return [new RowSezione(null, [
          new VoceSezione(3, 'text', 'Posizione', fascicolo.copertina.campi.identificativoFascicolo),
          new VoceSezione(3, 'text', 'Vecchia posizione', fascicolo.vecchiaPosizione),
          new VoceSezione(3, 'text', 'Tipo Fascicolo', fascicolo.copertina.campi.tipo),
          new VoceSezione(3, 'text', 'Natura', fascicolo.copertina.campi.natura)
        ]),
          new RowSezione(null, [
            new VoceSezione(12, 'textarea', 'Descrizione oggetto', fascicolo.descrizioneOggetto),
          ]),
          new RowSezione(null, [
            new VoceSezione(4, 'date', 'Data apertura fascicolo', fascicolo.copertina.campi.dataInizioFascicolo),
            new VoceSezione(4, 'date', 'Data ultima modifica', fascicolo.copertina.campi.dataUltimaModifica),
            new VoceSezione(4, 'text', 'Stato', fascicolo.copertina.campi.stato)
          ]),
          new RowSezione('Fascicolo opposto', [
            new VoceSezione(4, 'text', 'Posizione fascicolo', fascicolo.copertina.campi.posizioneFascicoloRif),
            new VoceSezione(4, 'text', 'N&deg; ruolo/decreto', fascicolo.copertina.campi.numRuoloDecretoRif),
            new VoceSezione(4, 'text', 'Motivo opposizione', fascicolo.copertina.campi.motivoOpposizione),
          ]),
          new RowSezione(null, [
            new VoceSezione(6, 'date', 'Data definizione', fascicolo.copertina.campi.dataDefinizione),
            new VoceSezione(6, 'text', 'Motivo definizione', fascicolo.copertina.campi.motivoDefinizione),
            //new VoceSezione(4, 'boolean', 'Fondo rischi', fascicolo.copertina.campi.fondoRischi)
          ]),
          new RowSezione(((fascicolo.copertina.campi.capofila || fascicolo.copertina.campi.riunito) ? 'Riunione dei giudizi' : ''), (fascicolo.copertina.campi.capofila || fascicolo.copertina.campi.riunito) ? [
            new VoceSezione(4, 'text', fascicolo.copertina.campi.capofila ? 'Capofila' : 'Riunito', 'Si'),
            new VoceSezione(4, 'date', 'Data riunione giudizio', fascicolo.copertina.campi.dataRiunioneGiudizio),
            new VoceSezione(4, 'text', 'Motivo riunione giudizio', fascicolo.copertina.campi.motivoRiunioneGiudizio)
          ] : [new VoceSezione(12, '', '', '')]),
          new RowSezione(null, [
            new VoceSezione(4, 'text', 'Parte primaria (n. controparti)', (fascicolo.copertina.campi.contropartePrimaria) + (' (' + fascicolo.copertina.campi.numeroControparti + ')')),
            //new VoceSezione(4, 'text', 'Legale incaricato', (fascicolo.copertina.campi.legaleIncaricato ? fascicolo.copertina.campi.legaleIncaricato : '') + (fascicolo.copertina.campi.tipologiaDiLegaleIncaricato ? ' (' + fascicolo.copertina.campi.tipologiaDiLegaleIncaricato + ')' : '')),
            new VoceSezione(4, 'text', 'Assegnatario', assegnatario),
            new VoceSezione(4, 'text', 'Visibilità', fascicolo.tipoVisibilita?.label ? fascicolo.tipoVisibilita?.label : (fascicolo.praticaBase.tipoVisibilita?.label ? fascicolo.praticaBase.tipoVisibilita?.label : null))
          ]),
          new RowSezione(null, [
            new VoceSezione(4, 'text', 'Numero/anno ruolo', (fascicolo.copertina.campi.numeroRuolo ? fascicolo.copertina.campi.numeroRuolo : '') + (fascicolo.copertina.campi.numeroRuolo && fascicolo.copertina.campi.annoRuolo ? '/' : '') + (fascicolo.copertina.campi.annoRuolo ? fascicolo.copertina.campi.annoRuolo : '')),
            new VoceSezione(4, 'text', 'Autorit&agrave; giudiziaria', (fascicolo.copertina.campi.autoritaGiudiziaria ? fascicolo.copertina.campi.autoritaGiudiziaria : '') + (fascicolo.copertina.campi.sedeAutoritaGiudiziaria != null ? ' di ' + (fascicolo.copertina.campi.sedeAutoritaGiudiziaria) : '')),
            new VoceSezione(4, 'text', 'Valore', fascicolo.copertina.campi.valore)
          ]),
          esiti.length > 0 ? new RowSezione("Esiti",esiti) : new RowSezione(null, null),
          udienzeEsiti.length > 0 ? new RowSezione("Udienze",udienzeEsiti) : new RowSezione(null,null),
          new RowSezione('Prossima udienza', [
            // new VoceSezione(4, 'date', 'Ultima udienza', fascicolo.copertina.campi.ultimaUdienza),
            new VoceSezione(6, 'text', 'Adempimento', fascicolo.copertina.campi.prossimaUdienzaTipoAdempimento),
            new VoceSezione(6, 'date', 'Prossima udienza', fascicolo.copertina.campi.prossimaUdienza),
            // new VoceSezione(4, 'date', 'Prossima scadenza', fascicolo.copertina.campi.prossimaScadenza)
          ]),
          new RowSezione('Competenze ', [
            new VoceSezione(12, 'text', 'Gruppi competenti', fascicolo.copertina.campi.competenza)
          ]),
        ];
        break;
      }
      case 'opposizione': {
        return [new RowSezione(null, [
          new VoceSezione(3, 'text', 'Posizione', fascicolo.copertina.campi.identificativoFascicolo),
          new VoceSezione(3, 'text', 'Vecchia posizione', fascicolo.vecchiaPosizione),
          new VoceSezione(3, 'text', 'Tipo Fascicolo', fascicolo.copertina.campi.tipo),
          new VoceSezione(3, 'text', 'Natura', fascicolo.copertina.campi.natura)
        ]),
          new RowSezione(null, [
            new VoceSezione(12, 'textarea', 'Descrizione oggetto', fascicolo.descrizioneOggetto),
          ]),
          new RowSezione(null, [
            new VoceSezione(4, 'date', 'Data apertura fascicolo', fascicolo.copertina.campi.dataInizioFascicolo),
            new VoceSezione(4, 'date', 'Data ultima modifica', fascicolo.copertina.campi.dataUltimaModifica),
            new VoceSezione(4, 'text', 'Stato', fascicolo.copertina.campi.stato)
          ]),
          new RowSezione('Fascicolo opposto', [
            new VoceSezione(4, 'text', 'Posizione fascicolo', fascicolo.copertina.campi.posizioneFascicoloRif),
            new VoceSezione(4, 'text', 'N&deg; ruolo/decreto', fascicolo.copertina.campi.numRuoloDecretoRif),
            new VoceSezione(4, 'text', 'Motivo opposizione', fascicolo.copertina.campi.motivoOpposizione),
          ]),
          new RowSezione(null, [
            new VoceSezione(6, 'date', 'Data definizione', fascicolo.copertina.campi.dataDefinizione),
            new VoceSezione(6, 'text', 'Motivo definizione', fascicolo.copertina.campi.motivoDefinizione),
            //new VoceSezione(4, 'boolean', 'Fondo rischi', fascicolo.copertina.campi.fondoRischi)
          ]),
          new RowSezione(((fascicolo.copertina.campi.capofila || fascicolo.copertina.campi.riunito) ? 'Riunione dei giudizi' : ''), (fascicolo.copertina.campi.capofila || fascicolo.copertina.campi.riunito) ? [
            new VoceSezione(4, 'text', fascicolo.copertina.campi.capofila ? 'Capofila' : 'Riunito', 'Si'),
            new VoceSezione(4, 'date', 'Data riunione giudizio', fascicolo.copertina.campi.dataRiunioneGiudizio),
            new VoceSezione(4, 'text', 'Motivo riunione giudizio', fascicolo.copertina.campi.motivoRiunioneGiudizio)
          ] : [new VoceSezione(12, '', '', '')]),
          new RowSezione(null, [
            new VoceSezione(4, 'text', 'Parte primaria (n. controparti)', (fascicolo.copertina.campi.contropartePrimaria) + (' (' + fascicolo.copertina.campi.numeroControparti + ')')),
            //new VoceSezione(4, 'text', 'Legale incaricato', (fascicolo.copertina.campi.legaleIncaricato ? fascicolo.copertina.campi.legaleIncaricato : '') + (fascicolo.copertina.campi.tipologiaDiLegaleIncaricato ? ' (' + fascicolo.copertina.campi.tipologiaDiLegaleIncaricato + ')' : '')),
            new VoceSezione(4, 'text', 'Assegnatario', assegnatario),
            new VoceSezione(4, 'text', 'Visibilità', fascicolo.tipoVisibilita?.label ? fascicolo.tipoVisibilita?.label : (fascicolo.praticaBase.tipoVisibilita?.label ? fascicolo.praticaBase.tipoVisibilita?.label : null))
          ]),
          new RowSezione(null, [
            new VoceSezione(4, 'text', 'Numero/anno ruolo', (fascicolo.copertina.campi.numeroRuolo ? fascicolo.copertina.campi.numeroRuolo : '') + (fascicolo.copertina.campi.numeroRuolo && fascicolo.copertina.campi.annoRuolo ? '/' : '') + (fascicolo.copertina.campi.annoRuolo ? fascicolo.copertina.campi.annoRuolo : '')),
            new VoceSezione(4, 'text', 'Autorit&agrave; giudiziaria', (fascicolo.copertina.campi.autoritaGiudiziaria ? fascicolo.copertina.campi.autoritaGiudiziaria : '') + (fascicolo.copertina.campi.sedeAutoritaGiudiziaria != null ? ' di ' + (fascicolo.copertina.campi.sedeAutoritaGiudiziaria) : '')),
            new VoceSezione(4, 'text', 'Valore', fascicolo.copertina.campi.valore)
          ]),
          esiti.length > 0 ? new RowSezione("Esiti",esiti) : new RowSezione(null, null),
          udienzeEsiti.length > 0 ? new RowSezione("Udienze",udienzeEsiti) : new RowSezione(null,null),
          new RowSezione('Prossima udienza', [
            // new VoceSezione(4, 'date', 'Ultima udienza', fascicolo.copertina.campi.ultimaUdienza),
            new VoceSezione(6, 'text', 'Adempimento', fascicolo.copertina.campi.prossimaUdienzaTipoAdempimento),
            new VoceSezione(6, 'date', 'Prossima udienza', fascicolo.copertina.campi.prossimaUdienza),
            // new VoceSezione(4, 'date', 'Prossima scadenza', fascicolo.copertina.campi.prossimaScadenza)
          ]),
          new RowSezione('Competenze ', [
            new VoceSezione(12, 'text', 'Gruppi competenti', fascicolo.copertina.campi.competenza)
          ]),
        ];
        break;
      }
      case 'opposizioneattiesecutivi': {
        return [new RowSezione(null, [
          new VoceSezione(3, 'text', 'Posizione', fascicolo.copertina.campi.identificativoFascicolo),
          new VoceSezione(3, 'text', 'Vecchia posizione', fascicolo.vecchiaPosizione),
          new VoceSezione(3, 'text', 'Tipo Fascicolo', fascicolo.copertina.campi.tipo),
          new VoceSezione(3, 'text', 'Natura', fascicolo.copertina.campi.natura)
        ]),
          new RowSezione(null, [
            new VoceSezione(12, 'textarea', 'Descrizione oggetto', fascicolo.descrizioneOggetto),
          ]),
          new RowSezione(null, [
            new VoceSezione(4, 'date', 'Data apertura fascicolo', fascicolo.copertina.campi.dataInizioFascicolo),
            new VoceSezione(4, 'date', 'Data ultima modifica', fascicolo.copertina.campi.dataUltimaModifica),
            new VoceSezione(4, 'text', 'Stato', fascicolo.copertina.campi.stato)
          ]),
          new RowSezione('Fascicolo opposto', [
            new VoceSezione(4, 'text', 'Posizione fascicolo', fascicolo.copertina.campi.posizioneFascicoloRif),
            new VoceSezione(4, 'text', 'N&deg; ruolo/decreto', fascicolo.copertina.campi.numRuoloDecretoRif),
            new VoceSezione(4, 'text', 'Motivo opposizione', fascicolo.copertina.campi.motivoOpposizione),
          ]),
          new RowSezione(null, [
            new VoceSezione(6, 'date', 'Data definizione', fascicolo.copertina.campi.dataDefinizione),
            new VoceSezione(6, 'text', 'Motivo definizione', fascicolo.copertina.campi.motivoDefinizione),
            //new VoceSezione(4, 'boolean', 'Fondo rischi', fascicolo.copertina.campi.fondoRischi)
          ]),
          new RowSezione(((fascicolo.copertina.campi.capofila || fascicolo.copertina.campi.riunito) ? 'Riunione dei giudizi' : ''), (fascicolo.copertina.campi.capofila || fascicolo.copertina.campi.riunito) ? [
            new VoceSezione(4, 'text', fascicolo.copertina.campi.capofila ? 'Capofila' : 'Riunito', 'Si'),
            new VoceSezione(4, 'date', 'Data riunione giudizio', fascicolo.copertina.campi.dataRiunioneGiudizio),
            new VoceSezione(4, 'text', 'Motivo riunione giudizio', fascicolo.copertina.campi.motivoRiunioneGiudizio)
          ] : [new VoceSezione(12, '', '', '')]),
          new RowSezione(null, [
            new VoceSezione(4, 'text', 'Parte primaria (n. controparti)', (fascicolo.copertina.campi.contropartePrimaria) + (' (' + fascicolo.copertina.campi.numeroControparti + ')')),
            //new VoceSezione(4, 'text', 'Legale incaricato', (fascicolo.copertina.campi.legaleIncaricato ? fascicolo.copertina.campi.legaleIncaricato : '') + (fascicolo.copertina.campi.tipologiaDiLegaleIncaricato ? ' (' + fascicolo.copertina.campi.tipologiaDiLegaleIncaricato + ')' : '')),
            new VoceSezione(4, 'text', 'Assegnatario', assegnatario),
            new VoceSezione(4, 'text', 'Visibilità', fascicolo.tipoVisibilita?.label ? fascicolo.tipoVisibilita?.label : (fascicolo.praticaBase.tipoVisibilita?.label ? fascicolo.praticaBase.tipoVisibilita?.label : null))
          ]),
          new RowSezione(null, [
            new VoceSezione(4, 'text', 'Numero/anno ruolo', (fascicolo.copertina.campi.numeroRuolo ? fascicolo.copertina.campi.numeroRuolo : '') + (fascicolo.copertina.campi.numeroRuolo && fascicolo.copertina.campi.annoRuolo ? '/' : '') + (fascicolo.copertina.campi.annoRuolo ? fascicolo.copertina.campi.annoRuolo : '')),
            new VoceSezione(4, 'text', 'Autorit&agrave; giudiziaria', (fascicolo.copertina.campi.autoritaGiudiziaria ? fascicolo.copertina.campi.autoritaGiudiziaria : '') + (fascicolo.copertina.campi.sedeAutoritaGiudiziaria != null ? ' di ' + (fascicolo.copertina.campi.sedeAutoritaGiudiziaria) : '')),
            new VoceSezione(4, 'text', 'Valore', fascicolo.copertina.campi.valore)
          ]),
          esiti.length > 0 ? new RowSezione("Esiti",esiti) : new RowSezione(null, null),
          udienzeEsiti.length > 0 ? new RowSezione("Udienze",udienzeEsiti) : new RowSezione(null,null),
          new RowSezione('Prossima udienza', [
            // new VoceSezione(4, 'date', 'Ultima udienza', fascicolo.copertina.campi.ultimaUdienza),
            new VoceSezione(6, 'text', 'Adempimento', fascicolo.copertina.campi.prossimaUdienzaTipoAdempimento),
            new VoceSezione(6, 'date', 'Prossima udienza', fascicolo.copertina.campi.prossimaUdienza),
            // new VoceSezione(4, 'date', 'Prossima scadenza', fascicolo.copertina.campi.prossimaScadenza)
          ]),
          new RowSezione('Competenze ', [
            new VoceSezione(12, 'text', 'Gruppi competenti', fascicolo.copertina.campi.competenza)
          ]),
        ];
        break;
      }
      case 'opposizioneprecetto': {
        return [new RowSezione(null, [
          new VoceSezione(3, 'text', 'Posizione', fascicolo.copertina.campi.identificativoFascicolo),
          new VoceSezione(3, 'text', 'Vecchia posizione', fascicolo.vecchiaPosizione),
          new VoceSezione(3, 'text', 'Tipo Fascicolo', fascicolo.copertina.campi.tipo),
          new VoceSezione(3, 'text', 'Natura', fascicolo.copertina.campi.natura)
        ]),
          new RowSezione(null, [
            new VoceSezione(12, 'textarea', 'Descrizione oggetto', fascicolo.descrizioneOggetto),
          ]),
          new RowSezione(null, [
            new VoceSezione(4, 'date', 'Data apertura fascicolo', fascicolo.copertina.campi.dataInizioFascicolo),
            new VoceSezione(4, 'date', 'Data ultima modifica', fascicolo.copertina.campi.dataUltimaModifica),
            new VoceSezione(4, 'text', 'Stato', fascicolo.copertina.campi.stato)
          ]),
          new RowSezione('Fascicolo opposto', [
            new VoceSezione(4, 'text', 'Posizione fascicolo', fascicolo.copertina.campi.posizioneFascicoloRif),
            new VoceSezione(4, 'text', 'N&deg; ruolo/decreto', fascicolo.copertina.campi.numRuoloDecretoRif),
            new VoceSezione(4, 'text', 'Motivo opposizione', fascicolo.copertina.campi.motivoOpposizione),
          ]),
          new RowSezione(null, [
            new VoceSezione(6, 'date', 'Data definizione', fascicolo.copertina.campi.dataDefinizione),
            new VoceSezione(6, 'text', 'Motivo definizione', fascicolo.copertina.campi.motivoDefinizione),
            //new VoceSezione(4, 'boolean', 'Fondo rischi', fascicolo.copertina.campi.fondoRischi)
          ]),
          new RowSezione(((fascicolo.copertina.campi.capofila || fascicolo.copertina.campi.riunito) ? 'Riunione dei giudizi' : ''), (fascicolo.copertina.campi.capofila || fascicolo.copertina.campi.riunito) ? [
            new VoceSezione(4, 'text', fascicolo.copertina.campi.capofila ? 'Capofila' : 'Riunito', 'Si'),
            new VoceSezione(4, 'date', 'Data riunione giudizio', fascicolo.copertina.campi.dataRiunioneGiudizio),
            new VoceSezione(4, 'text', 'Motivo riunione giudizio', fascicolo.copertina.campi.motivoRiunioneGiudizio)
          ] : [new VoceSezione(12, '', '', '')]),
          new RowSezione(null, [
            new VoceSezione(4, 'text', 'Parte primaria (n. controparti)', (fascicolo.copertina.campi.contropartePrimaria) + (' (' + fascicolo.copertina.campi.numeroControparti + ')')),
            //new VoceSezione(4, 'text', 'Legale incaricato', (fascicolo.copertina.campi.legaleIncaricato ? fascicolo.copertina.campi.legaleIncaricato : '') + (fascicolo.copertina.campi.tipologiaDiLegaleIncaricato ? ' (' + fascicolo.copertina.campi.tipologiaDiLegaleIncaricato + ')' : '')),
            new VoceSezione(4, 'text', 'Assegnatario', assegnatario),
            new VoceSezione(4, 'text', 'Visibilità', fascicolo.tipoVisibilita?.label ? fascicolo.tipoVisibilita?.label : (fascicolo.praticaBase.tipoVisibilita?.label ? fascicolo.praticaBase.tipoVisibilita?.label : null))
          ]),
          new RowSezione(null, [
            new VoceSezione(4, 'text', 'Numero/anno ruolo', (fascicolo.copertina.campi.numeroRuolo ? fascicolo.copertina.campi.numeroRuolo : '') + (fascicolo.copertina.campi.numeroRuolo && fascicolo.copertina.campi.annoRuolo ? '/' : '') + (fascicolo.copertina.campi.annoRuolo ? fascicolo.copertina.campi.annoRuolo : '')),
            new VoceSezione(4, 'text', 'Autorit&agrave; giudiziaria', (fascicolo.copertina.campi.autoritaGiudiziaria ? fascicolo.copertina.campi.autoritaGiudiziaria : '') + (fascicolo.copertina.campi.sedeAutoritaGiudiziaria != null ? ' di ' + (fascicolo.copertina.campi.sedeAutoritaGiudiziaria) : '')),
            new VoceSezione(4, 'text', 'Valore', fascicolo.copertina.campi.valore)
          ]),
          esiti.length > 0 ? new RowSezione("Esiti",esiti) : new RowSezione(null, null),
          udienzeEsiti.length > 0 ? new RowSezione("Udienze",udienzeEsiti) : new RowSezione(null,null),
          new RowSezione('Prossima udienza', [
            // new VoceSezione(4, 'date', 'Ultima udienza', fascicolo.copertina.campi.ultimaUdienza),
            new VoceSezione(6, 'text', 'Adempimento', fascicolo.copertina.campi.prossimaUdienzaTipoAdempimento),
            new VoceSezione(6, 'date', 'Prossima udienza', fascicolo.copertina.campi.prossimaUdienza),
            // new VoceSezione(4, 'date', 'Prossima scadenza', fascicolo.copertina.campi.prossimaScadenza)
          ]),
          new RowSezione('Competenze ', [
            new VoceSezione(12, 'text', 'Gruppi competenti', fascicolo.copertina.campi.competenza)
          ]),
        ];
        break;
      }
      case 'opposizioneesecuzione': {
        return [new RowSezione(null, [
          new VoceSezione(3, 'text', 'Posizione', fascicolo.copertina.campi.identificativoFascicolo),
          new VoceSezione(3, 'text', 'Vecchia posizione', fascicolo.vecchiaPosizione),
          new VoceSezione(3, 'text', 'Tipo Fascicolo', fascicolo.copertina.campi.tipo),
          new VoceSezione(3, 'text', 'Natura', fascicolo.copertina.campi.natura)
        ]),
          new RowSezione(null, [
            new VoceSezione(12, 'textarea', 'Descrizione oggetto', fascicolo.descrizioneOggetto),
          ]),
          new RowSezione(null, [
            new VoceSezione(4, 'date', 'Data apertura fascicolo', fascicolo.copertina.campi.dataInizioFascicolo),
            new VoceSezione(4, 'date', 'Data ultima modifica', fascicolo.copertina.campi.dataUltimaModifica),
            new VoceSezione(4, 'text', 'Stato', fascicolo.copertina.campi.stato)
          ]),
          new RowSezione('Fascicolo opposto', [
            new VoceSezione(4, 'text', 'Posizione fascicolo', fascicolo.copertina.campi.posizioneFascicoloRif),
            new VoceSezione(4, 'text', 'N&deg; ruolo/decreto', fascicolo.copertina.campi.numRuoloDecretoRif),
            new VoceSezione(4, 'text', 'Motivo opposizione', fascicolo.copertina.campi.motivoOpposizione),
          ]),
          new RowSezione(null, [
            new VoceSezione(6, 'date', 'Data definizione', fascicolo.copertina.campi.dataDefinizione),
            new VoceSezione(6, 'text', 'Motivo definizione', fascicolo.copertina.campi.motivoDefinizione),
            //new VoceSezione(4, 'boolean', 'Fondo rischi', fascicolo.copertina.campi.fondoRischi)
          ]),
          new RowSezione(((fascicolo.copertina.campi.capofila || fascicolo.copertina.campi.riunito) ? 'Riunione dei giudizi' : ''), (fascicolo.copertina.campi.capofila || fascicolo.copertina.campi.riunito) ? [
            new VoceSezione(4, 'text', fascicolo.copertina.campi.capofila ? 'Capofila' : 'Riunito', 'Si'),
            new VoceSezione(4, 'date', 'Data riunione giudizio', fascicolo.copertina.campi.dataRiunioneGiudizio),
            new VoceSezione(4, 'text', 'Motivo riunione giudizio', fascicolo.copertina.campi.motivoRiunioneGiudizio)
          ] : [new VoceSezione(12, '', '', '')]),
          new RowSezione(null, [
            new VoceSezione(4, 'text', 'Parte primaria (n. controparti)', (fascicolo.copertina.campi.contropartePrimaria) + (' (' + fascicolo.copertina.campi.numeroControparti + ')')),
            //new VoceSezione(4, 'text', 'Legale incaricato', (fascicolo.copertina.campi.legaleIncaricato ? fascicolo.copertina.campi.legaleIncaricato : '') + (fascicolo.copertina.campi.tipologiaDiLegaleIncaricato ? ' (' + fascicolo.copertina.campi.tipologiaDiLegaleIncaricato + ')' : '')),
            new VoceSezione(4, 'text', 'Assegnatario', assegnatario),
            new VoceSezione(4, 'text', 'Visibilità', fascicolo.tipoVisibilita?.label ? fascicolo.tipoVisibilita?.label : (fascicolo.praticaBase.tipoVisibilita?.label ? fascicolo.praticaBase.tipoVisibilita?.label : null))
          ]),
          new RowSezione(null, [
            new VoceSezione(4, 'text', 'Numero/anno ruolo', (fascicolo.copertina.campi.numeroRuolo ? fascicolo.copertina.campi.numeroRuolo : '') + (fascicolo.copertina.campi.numeroRuolo && fascicolo.copertina.campi.annoRuolo ? '/' : '') + (fascicolo.copertina.campi.annoRuolo ? fascicolo.copertina.campi.annoRuolo : '')),
            new VoceSezione(4, 'text', 'Autorit&agrave; giudiziaria', (fascicolo.copertina.campi.autoritaGiudiziaria ? fascicolo.copertina.campi.autoritaGiudiziaria : '') + (fascicolo.copertina.campi.sedeAutoritaGiudiziaria != null ? ' di ' + (fascicolo.copertina.campi.sedeAutoritaGiudiziaria) : '')),
            new VoceSezione(4, 'text', 'Valore', fascicolo.copertina.campi.valore)
          ]),
          esiti.length > 0 ? new RowSezione("Esiti",esiti) : new RowSezione(null, null),
          udienzeEsiti.length > 0 ? new RowSezione("Udienze",udienzeEsiti) : new RowSezione(null,null),
          new RowSezione('Prossima udienza', [
            // new VoceSezione(4, 'date', 'Ultima udienza', fascicolo.copertina.campi.ultimaUdienza),
            new VoceSezione(6, 'text', 'Adempimento', fascicolo.copertina.campi.prossimaUdienzaTipoAdempimento),
            new VoceSezione(6, 'date', 'Prossima udienza', fascicolo.copertina.campi.prossimaUdienza),
            // new VoceSezione(4, 'date', 'Prossima scadenza', fascicolo.copertina.campi.prossimaScadenza)
          ]),
          new RowSezione('Competenze ', [
            new VoceSezione(12, 'text', 'Gruppi competenti', fascicolo.copertina.campi.competenza)
          ]),
        ];
        break;
      }
      case 'cautelare': {
        return [new RowSezione(null, [
          new VoceSezione(3, 'text', 'Posizione', fascicolo.copertina.campi.identificativoFascicolo),
          new VoceSezione(3, 'text', 'Vecchia posizione', fascicolo.vecchiaPosizione),
          new VoceSezione(3, 'text', 'Tipo Fascicolo', fascicolo.copertina.campi.tipo),
          new VoceSezione(3, 'text', 'Stato', fascicolo.copertina.campi.stato)
        ]),
          new RowSezione(null, [
            new VoceSezione(3, 'text', 'Natura', fascicolo.copertina.campi.natura),
            new VoceSezione(3, 'text', 'Parti', fascicolo.copertina.campi.parti),
            new VoceSezione(3, 'text', 'Assegnatario', assegnatario),
            new VoceSezione(3, 'text', 'Legale di controparte', fascicolo.copertina.campi.legaliControparti)
          ]),
          new RowSezione(null, [
            new VoceSezione(12, 'text', 'Fondo rischi SI/NO', true === fascicolo.copertina.campi.fondoRischi ? 'Si' : 'No'),
          ]),
          new RowSezione('Dati Giudiziari', [
            new VoceSezione(4, 'text', 'Autorit&agrave; giudiziaria', (fascicolo.copertina.campi.autoritaGiudiziaria ? fascicolo.copertina.campi.autoritaGiudiziaria : '')),
            new VoceSezione(4, 'text', 'Sede', fascicolo.copertina.campi.sedeAutoritaGiudiziaria),
            new VoceSezione(4, 'text', 'Grado', (fascicolo.copertina.campi.grado ? fascicolo.copertina.campi.grado : '')),
            new VoceSezione(6, 'text', 'Numero/anno ruolo', (fascicolo.copertina.campi.numeroRuolo ? fascicolo.copertina.campi.numeroRuolo : '') + (fascicolo.copertina.campi.numeroRuolo && fascicolo.copertina.campi.annoRuolo ? '/' : '') + (fascicolo.copertina.campi.annoRuolo ? fascicolo.copertina.campi.annoRuolo : '')),
            new VoceSezione(6, 'text', 'Sezione', fascicolo.copertina.campi.sezione)
          ]),
          new RowSezione(null, [
            new VoceSezione(12, 'textarea', 'Descrizione oggetto', fascicolo.descrizioneOggetto),
          ]),
          new RowSezione(null, [
            new VoceSezione(4, 'date', 'Data apertura fascicolo', fascicolo.copertina.campi.dataInizioFascicolo),
            new VoceSezione(4, 'date', 'Data notifica', fascicolo.dataNotifica),
            new VoceSezione(4, 'date', 'Data prima comparizione', fascicolo.dataPrimaComparizione)
          ]),
          new RowSezione(null, [
            new VoceSezione(4, 'text', 'Costituzione SI/NO', true === fascicolo.flagCostituzione ? 'Si' : 'No'),
            new VoceSezione(4, 'text', 'Motivazione', fascicolo.motivazione ? fascicolo.motivazione.label : ''),
            new VoceSezione(4, 'date', 'Data costituzione', fascicolo.dataCostituzione)
          ]),
          new RowSezione(((fascicolo.copertina.campi.capofila || fascicolo.copertina.campi.riunito) ? 'Riunione dei giudizi' : ''), (fascicolo.copertina.campi.capofila || fascicolo.copertina.campi.riunito) ? [
            new VoceSezione(4, 'text', fascicolo.copertina.campi.capofila ? 'Capofila' : 'Riunito', 'Si'),
            new VoceSezione(4, 'date', 'Data riunione giudizio', fascicolo.copertina.campi.dataRiunioneGiudizio),
            new VoceSezione(4, 'text', 'Motivo riunione giudizio', fascicolo.copertina.campi.motivoRiunioneGiudizio)
          ] : [new VoceSezione(12, '', '', '')]),
          esiti.length > 0 ? new RowSezione("Esiti",esiti) : new RowSezione(null, null),
          udienzeEsiti.length > 0 ? new RowSezione("Udienze",udienzeEsiti) : new RowSezione(null,null),
          new RowSezione('Prossima udienza', [
            // new VoceSezione(4, 'date', 'Ultima udienza', fascicolo.copertina.campi.ultimaUdienza),
            new VoceSezione(6, 'text', 'Adempimento', fascicolo.copertina.campi.prossimaUdienzaTipoAdempimento),
            new VoceSezione(6, 'date', 'Prossima udienza', fascicolo.copertina.campi.prossimaUdienza),
            // new VoceSezione(4, 'date', 'Prossima scadenza', fascicolo.copertina.campi.prossimaScadenza)
          ]),
          new RowSezione('Competenze ', [
            new VoceSezione(12, 'text', 'Gruppi competenti', fascicolo.copertina.campi.competenza)
          ]),
        ];
        break;
      }
      case 'speciale': {
        return [new RowSezione(null, [
          new VoceSezione(3, 'text', 'Posizione', fascicolo.copertina.campi.identificativoFascicolo),
          new VoceSezione(3, 'text', 'Vecchia posizione', fascicolo.vecchiaPosizione),
          new VoceSezione(3, 'text', 'Tipo Fascicolo', fascicolo.copertina.campi.tipo),
          new VoceSezione(3, 'text', 'Stato', fascicolo.copertina.campi.stato)
        ]),
          new RowSezione(null, [
            new VoceSezione(3, 'text', 'Natura', fascicolo.copertina.campi.natura),
            new VoceSezione(3, 'text', 'Parti', fascicolo.copertina.campi.parti),
            new VoceSezione(3, 'text', 'Assegnatario', assegnatario),
            new VoceSezione(3, 'text', 'Legale di controparte', fascicolo.copertina.campi.legaliControparti)
          ]),
          new RowSezione(null, [
            new VoceSezione(12, 'text', 'Fondo rischi SI/NO', true === fascicolo.copertina.campi.fondoRischi ? 'Si' : 'No'),
          ]),
          new RowSezione('Dati Giudiziari', [
            new VoceSezione(4, 'text', 'Autorit&agrave; giudiziaria', (fascicolo.copertina.campi.autoritaGiudiziaria ? fascicolo.copertina.campi.autoritaGiudiziaria : '')),
            new VoceSezione(4, 'text', 'Sede', fascicolo.copertina.campi.sedeAutoritaGiudiziaria),
            new VoceSezione(4, 'text', 'Grado', (fascicolo.copertina.campi.grado ? fascicolo.copertina.campi.grado : '')),
            new VoceSezione(6, 'text', 'Numero/anno ruolo', (fascicolo.copertina.campi.numeroRuolo ? fascicolo.copertina.campi.numeroRuolo : '') + (fascicolo.copertina.campi.numeroRuolo && fascicolo.copertina.campi.annoRuolo ? '/' : '') + (fascicolo.copertina.campi.annoRuolo ? fascicolo.copertina.campi.annoRuolo : '')),
            new VoceSezione(6, 'text', 'Sezione', fascicolo.copertina.campi.sezione)
          ]),
          new RowSezione(null, [
            new VoceSezione(12, 'textarea', 'Descrizione oggetto', fascicolo.descrizioneOggetto),
          ]),
          new RowSezione(null, [
            new VoceSezione(4, 'date', 'Data apertura fascicolo', fascicolo.copertina.campi.dataInizioFascicolo),
            new VoceSezione(4, 'date', 'Data notifica', fascicolo.dataNotifica),
            new VoceSezione(4, 'date', 'Data prima comparizione', fascicolo.dataPrimaComparizione)
          ]),
          new RowSezione(null, [
            new VoceSezione(4, 'text', 'Costituzione SI/NO', true === fascicolo.flagCostituzione ? 'Si' : 'No'),
            new VoceSezione(4, 'text', 'Motivazione', fascicolo.motivazione ? fascicolo.motivazione.label : ''),
            new VoceSezione(4, 'date', 'Data costituzione', fascicolo.dataCostituzione)
          ]),
          new RowSezione(((fascicolo.copertina.campi.capofila || fascicolo.copertina.campi.riunito) ? 'Riunione dei giudizi' : ''), (fascicolo.copertina.campi.capofila || fascicolo.copertina.campi.riunito) ? [
            new VoceSezione(4, 'text', fascicolo.copertina.campi.capofila ? 'Capofila' : 'Riunito', 'Si'),
            new VoceSezione(4, 'date', 'Data riunione giudizio', fascicolo.copertina.campi.dataRiunioneGiudizio),
            new VoceSezione(4, 'text', 'Motivo riunione giudizio', fascicolo.copertina.campi.motivoRiunioneGiudizio)
          ] : [new VoceSezione(12, '', '', '')]),
          esiti.length > 0 ? new RowSezione("Esiti",esiti) : new RowSezione(null, null),
          udienzeEsiti.length > 0 ? new RowSezione("Udienze",udienzeEsiti) : new RowSezione(null,null),
          new RowSezione('Prossima udienza', [
            // new VoceSezione(4, 'date', 'Ultima udienza', fascicolo.copertina.campi.ultimaUdienza),
            new VoceSezione(6, 'text', 'Adempimento', fascicolo.copertina.campi.prossimaUdienzaTipoAdempimento),
            new VoceSezione(6, 'date', 'Prossima udienza', fascicolo.copertina.campi.prossimaUdienza),
            // new VoceSezione(4, 'date', 'Prossima scadenza', fascicolo.copertina.campi.prossimaScadenza)
          ]),
          new RowSezione('Competenze ', [
            new VoceSezione(12, 'text', 'Gruppi competenti', fascicolo.copertina.campi.competenza)
          ]),
        ];
        break;
      }

      case 'sommariourgenza': {
        return [new RowSezione(null, [
          new VoceSezione(3, 'text', 'Posizione', fascicolo.copertina.campi.identificativoFascicolo),
          new VoceSezione(3, 'text', 'Vecchia posizione', fascicolo.vecchiaPosizione),
          new VoceSezione(3, 'text', 'Tipo Fascicolo', fascicolo.copertina.campi.tipo),
          new VoceSezione(3, 'text', 'Natura', fascicolo.copertina.campi.natura)
        ]),
          new RowSezione(null, [
            new VoceSezione(12, 'textarea', 'Descrizione oggetto', fascicolo.descrizioneOggetto),
          ]),
          new RowSezione(null, [
            new VoceSezione(4, 'date', 'Data apertura fascicolo', fascicolo.copertina.campi.dataInizioFascicolo),
            new VoceSezione(4, 'date', 'Data ultima modifica', fascicolo.copertina.campi.dataUltimaModifica),
            new VoceSezione(4, 'text', 'Stato', fascicolo.copertina.campi.stato)
          ]),
          new RowSezione(null, [
            new VoceSezione(6, 'date', 'Data definizione', fascicolo.copertina.campi.dataDefinizione),
            new VoceSezione(6, 'text', 'Motivo definizione', fascicolo.copertina.campi.motivoDefinizione),
            //new VoceSezione(4, 'boolean', 'Fondo rischi', fascicolo.copertina.campi.fondoRischi)
          ]),
          new RowSezione(((fascicolo.copertina.campi.capofila || fascicolo.copertina.campi.riunito) ? 'Riunione dei giudizi' : ''), (fascicolo.copertina.campi.capofila || fascicolo.copertina.campi.riunito) ? [
            new VoceSezione(4, 'text', fascicolo.copertina.campi.capofila ? 'Capofila' : 'Riunito', 'Si'),
            new VoceSezione(4, 'date', 'Data riunione giudizio', fascicolo.copertina.campi.dataRiunioneGiudizio),
            new VoceSezione(4, 'text', 'Motivo riunione giudizio', fascicolo.copertina.campi.motivoRiunioneGiudizio)
          ] : [new VoceSezione(12, '', '', '')]),
          new RowSezione(null, [
            new VoceSezione(4, 'text', 'Parte primaria (n. controparti)', (fascicolo.copertina.campi.contropartePrimaria) + (' (' + fascicolo.copertina.campi.numeroControparti + ')')),
            //new VoceSezione(4, 'text', 'Legale incaricato', (fascicolo.copertina.campi.legaleIncaricato ? fascicolo.copertina.campi.legaleIncaricato : '') + (fascicolo.copertina.campi.tipologiaDiLegaleIncaricato ? ' (' + fascicolo.copertina.campi.tipologiaDiLegaleIncaricato + ')' : '')),
            new VoceSezione(4, 'text', 'Assegnatario', assegnatario),
            new VoceSezione(4, 'text', 'Visibilità', fascicolo.tipoVisibilita?.label ? fascicolo.tipoVisibilita?.label : (fascicolo.praticaBase.tipoVisibilita?.label ? fascicolo.praticaBase.tipoVisibilita?.label : null))
          ]),
          esiti.length > 0 ? new RowSezione("Esiti",esiti) : new RowSezione(null, null),
          udienzeEsiti.length > 0 ? new RowSezione("Udienze",udienzeEsiti) : new RowSezione(null,null),
          new RowSezione('Prossima udienza', [
            // new VoceSezione(4, 'date', 'Ultima udienza', fascicolo.copertina.campi.ultimaUdienza),
            new VoceSezione(6, 'text', 'Adempimento', fascicolo.copertina.campi.prossimaUdienzaTipoAdempimento),
            new VoceSezione(6, 'date', 'Prossima udienza', fascicolo.copertina.campi.prossimaUdienza),
            // new VoceSezione(4, 'date', 'Prossima scadenza', fascicolo.copertina.campi.prossimaScadenza)
          ]),
          new RowSezione('Competenze ', [
            new VoceSezione(12, 'text', 'Gruppi competenti', fascicolo.copertina.campi.competenza)
          ]),
        ];
        break;
      }
      case 'esecuzioneimmobiliare': {
        return [new RowSezione(null, [
          new VoceSezione(3, 'text', 'Posizione', fascicolo.copertina.campi.identificativoFascicolo),
          new VoceSezione(3, 'text', 'Vecchia posizione', fascicolo.vecchiaPosizione),
          new VoceSezione(3, 'text', 'Tipo Fascicolo', fascicolo.copertina.campi.tipo),
          new VoceSezione(3, 'text', 'Stato', fascicolo.copertina.campi.stato)
        ]),
          new RowSezione(null, [
            new VoceSezione(3, 'text', 'Natura', fascicolo.copertina.campi.natura),
            new VoceSezione(3, 'text', 'Parti', fascicolo.copertina.campi.parti),
            new VoceSezione(3, 'text', 'Assegnatario', assegnatario),
            new VoceSezione(3, 'text', 'Legale di controparte', fascicolo.copertina.campi.legaliControparti)
          ]),
          new RowSezione(null, [
            new VoceSezione(12, 'text', 'Fondo rischi SI/NO', true === fascicolo.copertina.campi.fondoRischi ? 'Si' : 'No'),
          ]),
          new RowSezione('Dati Giudiziari', [
            new VoceSezione(4, 'text', 'Autorit&agrave; giudiziaria', (fascicolo.copertina.campi.autoritaGiudiziaria ? fascicolo.copertina.campi.autoritaGiudiziaria : '')),
            new VoceSezione(4, 'text', 'Sede', fascicolo.copertina.campi.sedeAutoritaGiudiziaria),
            new VoceSezione(4, 'text', 'Grado', (fascicolo.copertina.campi.grado ? fascicolo.copertina.campi.grado : '')),
            new VoceSezione(6, 'text', 'Numero/anno ruolo', (fascicolo.copertina.campi.numeroRuolo ? fascicolo.copertina.campi.numeroRuolo : '') + (fascicolo.copertina.campi.numeroRuolo && fascicolo.copertina.campi.annoRuolo ? '/' : '') + (fascicolo.copertina.campi.annoRuolo ? fascicolo.copertina.campi.annoRuolo : '')),
            new VoceSezione(6, 'text', 'Sezione', fascicolo.copertina.campi.sezione)
          ]),
          new RowSezione(null, [
            new VoceSezione(12, 'textarea', 'Descrizione oggetto', fascicolo.descrizioneOggetto),
          ]),
          new RowSezione(null, [
            new VoceSezione(4, 'date', 'Data apertura fascicolo', fascicolo.copertina.campi.dataInizioFascicolo),
            new VoceSezione(4, 'date', 'Data notifica', fascicolo.dataNotifica),
            new VoceSezione(4, 'date', 'Data prima comparizione', fascicolo.dataPrimaComparizione)
          ]),
          new RowSezione(null, [
            new VoceSezione(4, 'text', 'Costituzione SI/NO', true === fascicolo.flagCostituzione ? 'Si' : 'No'),
            new VoceSezione(4, 'text', 'Motivazione', fascicolo.motivazione ? fascicolo.motivazione.label : ''),
            new VoceSezione(4, 'date', 'Data costituzione', fascicolo.dataCostituzione)
          ]),
          new RowSezione(((fascicolo.copertina.campi.capofila || fascicolo.copertina.campi.riunito) ? 'Riunione dei giudizi' : ''), (fascicolo.copertina.campi.capofila || fascicolo.copertina.campi.riunito) ? [
            new VoceSezione(4, 'text', fascicolo.copertina.campi.capofila ? 'Capofila' : 'Riunito', 'Si'),
            new VoceSezione(4, 'date', 'Data riunione giudizio', fascicolo.copertina.campi.dataRiunioneGiudizio),
            new VoceSezione(4, 'text', 'Motivo riunione giudizio', fascicolo.copertina.campi.motivoRiunioneGiudizio)
          ] : [new VoceSezione(12, '', '', '')]),
          new RowSezione('Pignoramenti', [
            new VoceSezione(4, 'importo', 'Valore precetto di riferimento', fascicolo.copertina.campi.valorePrecettoDiRiferimento),
            new VoceSezione(4, 'importo', 'Totale valore beni pignorati', fascicolo.copertina.campi.totaleValoreDeiBeniPignorati),
            new VoceSezione(4, 'importo', 'Totale ricavato dalla vendita', fascicolo.copertina.campi.totaleRicavatoDallaVendita)
          ]),
          esiti.length > 0 ? new RowSezione("Esiti",esiti) : new RowSezione(null, null),
          udienzeEsiti.length > 0 ? new RowSezione("Udienze",udienzeEsiti) : new RowSezione(null,null),
          new RowSezione('Prossima udienza', [
            // new VoceSezione(4, 'date', 'Ultima udienza', fascicolo.copertina.campi.ultimaUdienza),
            new VoceSezione(6, 'text', 'Adempimento', fascicolo.copertina.campi.prossimaUdienzaTipoAdempimento),
            new VoceSezione(6, 'date', 'Prossima udienza', fascicolo.copertina.campi.prossimaUdienza),
            // new VoceSezione(4, 'date', 'Prossima scadenza', fascicolo.copertina.campi.prossimaScadenza)
          ]),
          new RowSezione('Competenze ', [
            new VoceSezione(12, 'text', 'Gruppi competenti', fascicolo.copertina.campi.competenza)
          ]),
        ];
        break;
      }
      case 'esecuzionemobiliare': {
        return [new RowSezione(null, [
          new VoceSezione(3, 'text', 'Posizione', fascicolo.copertina.campi.identificativoFascicolo),
          new VoceSezione(3, 'text', 'Vecchia posizione', fascicolo.vecchiaPosizione),
          new VoceSezione(3, 'text', 'Tipo Fascicolo', fascicolo.copertina.campi.tipo),
          new VoceSezione(3, 'text', 'Stato', fascicolo.copertina.campi.stato)
        ]),
          new RowSezione(null, [
            new VoceSezione(3, 'text', 'Natura', fascicolo.copertina.campi.natura),
            new VoceSezione(3, 'text', 'Parti', fascicolo.copertina.campi.parti),
            new VoceSezione(3, 'text', 'Assegnatario', assegnatario),
            new VoceSezione(3, 'text', 'Legale di controparte', fascicolo.copertina.campi.legaliControparti)
          ]),
          new RowSezione(null, [
            new VoceSezione(12, 'text', 'Fondo rischi SI/NO', true === fascicolo.copertina.campi.fondoRischi ? 'Si' : 'No'),
          ]),
          new RowSezione('Dati Giudiziari', [
            new VoceSezione(4, 'text', 'Autorit&agrave; giudiziaria', (fascicolo.copertina.campi.autoritaGiudiziaria ? fascicolo.copertina.campi.autoritaGiudiziaria : '')),
            new VoceSezione(4, 'text', 'Sede', fascicolo.copertina.campi.sedeAutoritaGiudiziaria),
            new VoceSezione(4, 'text', 'Grado', (fascicolo.copertina.campi.grado ? fascicolo.copertina.campi.grado : '')),
            new VoceSezione(6, 'text', 'Numero/anno ruolo', (fascicolo.copertina.campi.numeroRuolo ? fascicolo.copertina.campi.numeroRuolo : '') + (fascicolo.copertina.campi.numeroRuolo && fascicolo.copertina.campi.annoRuolo ? '/' : '') + (fascicolo.copertina.campi.annoRuolo ? fascicolo.copertina.campi.annoRuolo : '')),
            new VoceSezione(6, 'text', 'Sezione', fascicolo.copertina.campi.sezione)
          ]),
          new RowSezione(null, [
            new VoceSezione(12, 'textarea', 'Descrizione oggetto', fascicolo.descrizioneOggetto),
          ]),
          new RowSezione(null, [
            new VoceSezione(4, 'date', 'Data apertura fascicolo', fascicolo.copertina.campi.dataInizioFascicolo),
            new VoceSezione(4, 'date', 'Data notifica', fascicolo.dataNotifica),
            new VoceSezione(4, 'date', 'Data prima comparizione', fascicolo.dataPrimaComparizione)
          ]),
          new RowSezione(null, [
            new VoceSezione(4, 'text', 'Costituzione SI/NO', true === fascicolo.flagCostituzione ? 'Si' : 'No'),
            new VoceSezione(4, 'text', 'Motivazione', fascicolo.motivazione ? fascicolo.motivazione.label : ''),
            new VoceSezione(4, 'date', 'Data costituzione', fascicolo.dataCostituzione)
          ]),
          new RowSezione(((fascicolo.copertina.campi.capofila || fascicolo.copertina.campi.riunito) ? 'Riunione dei giudizi' : ''), (fascicolo.copertina.campi.capofila || fascicolo.copertina.campi.riunito) ? [
            new VoceSezione(4, 'text', fascicolo.copertina.campi.capofila ? 'Capofila' : 'Riunito', 'Si'),
            new VoceSezione(4, 'date', 'Data riunione giudizio', fascicolo.copertina.campi.dataRiunioneGiudizio),
            new VoceSezione(4, 'text', 'Motivo riunione giudizio', fascicolo.copertina.campi.motivoRiunioneGiudizio)
          ] : [new VoceSezione(12, '', '', '')]),
          new RowSezione('Pignoramenti', [
            new VoceSezione(4, 'importo', 'Valore precetto di riferimento', fascicolo.copertina.campi.valorePrecettoDiRiferimento),
            new VoceSezione(4, 'importo', 'Totale valore beni pignorati', fascicolo.copertina.campi.totaleValoreDeiBeniPignorati),
            new VoceSezione(4, 'importo', 'Totale ricavato dalla vendita', fascicolo.copertina.campi.totaleRicavatoDallaVendita)
          ]),
          esiti.length > 0 ? new RowSezione("Esiti",esiti) : new RowSezione(null, null),
          udienzeEsiti.length > 0 ? new RowSezione("Udienze",udienzeEsiti) : new RowSezione(null,null),
          new RowSezione('Prossima udienza', [
            // new VoceSezione(4, 'date', 'Ultima udienza', fascicolo.copertina.campi.ultimaUdienza),
            new VoceSezione(6, 'text', 'Adempimento', fascicolo.copertina.campi.prossimaUdienzaTipoAdempimento),
            new VoceSezione(6, 'date', 'Prossima udienza', fascicolo.copertina.campi.prossimaUdienza),
            // new VoceSezione(4, 'date', 'Prossima scadenza', fascicolo.copertina.campi.prossimaScadenza)
          ]),
          new RowSezione('Competenze ', [
            new VoceSezione(12, 'text', 'Gruppi competenti', fascicolo.copertina.campi.competenza)
          ]),
        ];
        break;
      }
      case 'esecuzionepressoterzi': {
        return [new RowSezione(null, [
          new VoceSezione(3, 'text', 'Posizione', fascicolo.copertina.campi.identificativoFascicolo),
          new VoceSezione(3, 'text', 'Vecchia posizione', fascicolo.vecchiaPosizione),
          new VoceSezione(3, 'text', 'Tipo Fascicolo', fascicolo.copertina.campi.tipo),
          new VoceSezione(3, 'text', 'Stato', fascicolo.copertina.campi.stato)
        ]),
          new RowSezione(null, [
            new VoceSezione(3, 'text', 'Natura', fascicolo.copertina.campi.natura),
            new VoceSezione(3, 'text', 'Parti', fascicolo.copertina.campi.parti),
            new VoceSezione(3, 'text', 'Assegnatario', assegnatario),
            new VoceSezione(3, 'text', 'Legale di controparte', fascicolo.copertina.campi.legaliControparti)
          ]),
          new RowSezione(null, [
            new VoceSezione(12, 'text', 'Fondo rischi SI/NO', true === fascicolo.copertina.campi.fondoRischi ? 'Si' : 'No'),
          ]),
          new RowSezione('Dati Giudiziari', [
            new VoceSezione(4, 'text', 'Autorit&agrave; giudiziaria', (fascicolo.copertina.campi.autoritaGiudiziaria ? fascicolo.copertina.campi.autoritaGiudiziaria : '')),
            new VoceSezione(4, 'text', 'Sede', fascicolo.copertina.campi.sedeAutoritaGiudiziaria),
            new VoceSezione(4, 'text', 'Grado', (fascicolo.copertina.campi.grado ? fascicolo.copertina.campi.grado : '')),
            new VoceSezione(6, 'text', 'Numero/anno ruolo', (fascicolo.copertina.campi.numeroRuolo ? fascicolo.copertina.campi.numeroRuolo : '') + (fascicolo.copertina.campi.numeroRuolo && fascicolo.copertina.campi.annoRuolo ? '/' : '') + (fascicolo.copertina.campi.annoRuolo ? fascicolo.copertina.campi.annoRuolo : '')),
            new VoceSezione(6, 'text', 'Sezione', fascicolo.copertina.campi.sezione)
          ]),
          new RowSezione(null, [
            new VoceSezione(12, 'textarea', 'Descrizione oggetto', fascicolo.descrizioneOggetto),
          ]),
          new RowSezione(null, [
            new VoceSezione(4, 'date', 'Data apertura fascicolo', fascicolo.copertina.campi.dataInizioFascicolo),
            new VoceSezione(4, 'date', 'Data notifica', fascicolo.dataNotifica),
            new VoceSezione(4, 'date', 'Data prima comparizione', fascicolo.dataPrimaComparizione)
          ]),
          new RowSezione(null, [
            new VoceSezione(4, 'text', 'Costituzione SI/NO', true === fascicolo.flagCostituzione ? 'Si' : 'No'),
            new VoceSezione(4, 'text', 'Motivazione', fascicolo.motivazione ? fascicolo.motivazione.label : ''),
            new VoceSezione(4, 'date', 'Data costituzione', fascicolo.dataCostituzione)
          ]),
          new RowSezione(((fascicolo.copertina.campi.capofila || fascicolo.copertina.campi.riunito) ? 'Riunione dei giudizi' : ''), (fascicolo.copertina.campi.capofila || fascicolo.copertina.campi.riunito) ? [
            new VoceSezione(4, 'text', fascicolo.copertina.campi.capofila ? 'Capofila' : 'Riunito', 'Si'),
            new VoceSezione(4, 'date', 'Data riunione giudizio', fascicolo.copertina.campi.dataRiunioneGiudizio),
            new VoceSezione(4, 'text', 'Motivo riunione giudizio', fascicolo.copertina.campi.motivoRiunioneGiudizio)
          ] : [new VoceSezione(12, '', '', '')]),
          new RowSezione('Pignoramenti', [
            new VoceSezione(4, 'importo', 'Valore precetto di riferimento', fascicolo.copertina.campi.valorePrecettoDiRiferimento),
            new VoceSezione(4, 'importo', 'Totale valore beni pignorati', fascicolo.copertina.campi.totaleValoreDeiBeniPignorati),
            new VoceSezione(4, 'importo', 'Totale ricavato dalla vendita', fascicolo.copertina.campi.totaleRicavatoDallaVendita)
          ]),
          esiti.length > 0 ? new RowSezione("Esiti",esiti) : new RowSezione(null, null),
          udienzeEsiti.length > 0 ? new RowSezione("Udienze",udienzeEsiti) : new RowSezione(null,null),
          new RowSezione('Prossima udienza', [
            // new VoceSezione(4, 'date', 'Ultima udienza', fascicolo.copertina.campi.ultimaUdienza),
            new VoceSezione(6, 'text', 'Adempimento', fascicolo.copertina.campi.prossimaUdienzaTipoAdempimento),
            new VoceSezione(6, 'date', 'Prossima udienza', fascicolo.copertina.campi.prossimaUdienza),
            // new VoceSezione(4, 'date', 'Prossima scadenza', fascicolo.copertina.campi.prossimaScadenza)
          ]),
          new RowSezione('Terzi pignorati', [
            new VoceSezione(12, 'text', 'Soggetti terzi pignorati', fascicolo.copertina.campi.listaTerziPignorati)
          ]),
          new RowSezione('Competenze ', [
            new VoceSezione(12, 'text', 'Gruppi competenti', fascicolo.copertina.campi.competenza)
          ]),
        ];
        break;
      }
      case 'azionemonitoria': {
        return [new RowSezione(null, [
          new VoceSezione(3, 'text', 'Posizione', fascicolo.copertina.campi.identificativoFascicolo),
          new VoceSezione(3, 'text', 'Vecchia posizione', fascicolo.vecchiaPosizione),
          new VoceSezione(3, 'text', 'Tipo Fascicolo', fascicolo.copertina.campi.tipo),
          new VoceSezione(3, 'text', 'Stato', fascicolo.copertina.campi.stato)
        ]),
          new RowSezione(null, [
            new VoceSezione(3, 'text', 'Natura', fascicolo.copertina.campi.natura),
            new VoceSezione(3, 'text', 'Parti', fascicolo.copertina.campi.parti),
            new VoceSezione(3, 'text', 'Assegnatario', assegnatario),
            new VoceSezione(3, 'text', 'Legale di controparte', fascicolo.copertina.campi.legaliControparti)
          ]),
          new RowSezione(null, [
            new VoceSezione(12, 'text', 'Fondo rischi SI/NO', true === fascicolo.copertina.campi.fondoRischi ? 'Si' : 'No'),
          ]),
          new RowSezione('Dati Giudiziari', [
            new VoceSezione(4, 'text', 'Autorit&agrave; giudiziaria', (fascicolo.copertina.campi.autoritaGiudiziaria ? fascicolo.copertina.campi.autoritaGiudiziaria : '')),
            new VoceSezione(4, 'text', 'Sede', fascicolo.copertina.campi.sedeAutoritaGiudiziaria),
            new VoceSezione(4, 'text', 'Grado', (fascicolo.copertina.campi.grado ? fascicolo.copertina.campi.grado : '')),
            new VoceSezione(6, 'text', 'Numero/anno ruolo', (fascicolo.copertina.campi.numeroRuolo ? fascicolo.copertina.campi.numeroRuolo : '') + (fascicolo.copertina.campi.numeroRuolo && fascicolo.copertina.campi.annoRuolo ? '/' : '') + (fascicolo.copertina.campi.annoRuolo ? fascicolo.copertina.campi.annoRuolo : '')),
            new VoceSezione(6, 'text', 'Sezione', fascicolo.copertina.campi.sezione)
          ]),
          new RowSezione(null, [
            new VoceSezione(12, 'textarea', 'Descrizione oggetto', fascicolo.descrizioneOggetto),
          ]),
          new RowSezione(null, [
            new VoceSezione(4, 'date', 'Data apertura fascicolo', fascicolo.copertina.campi.dataInizioFascicolo),
            new VoceSezione(4, 'date', 'Data notifica', fascicolo.dataNotifica),
            new VoceSezione(4, 'date', 'Data prima comparizione', fascicolo.dataPrimaComparizione)
          ]),
          new RowSezione(null, [
            new VoceSezione(4, 'text', 'Costituzione SI/NO', true === fascicolo.flagCostituzione ? 'Si' : 'No'),
            new VoceSezione(4, 'text', 'Motivazione', fascicolo.motivazione ? fascicolo.motivazione.label : ''),
            new VoceSezione(4, 'date', 'Data costituzione', fascicolo.dataCostituzione)
          ]),
          new RowSezione(((fascicolo.copertina.campi.capofila || fascicolo.copertina.campi.riunito) ? 'Riunione dei giudizi' : ''), (fascicolo.copertina.campi.capofila || fascicolo.copertina.campi.riunito) ? [
            new VoceSezione(4, 'text', fascicolo.copertina.campi.capofila ? 'Capofila' : 'Riunito', 'Si'),
            new VoceSezione(4, 'date', 'Data riunione giudizio', fascicolo.copertina.campi.dataRiunioneGiudizio),
            new VoceSezione(4, 'text', 'Motivo riunione giudizio', fascicolo.copertina.campi.motivoRiunioneGiudizio)
          ] : [new VoceSezione(12, '', '', '')]),
          esiti.length > 0 ? new RowSezione("Esiti",esiti) : new RowSezione(null, null),
          udienzeEsiti.length > 0 ? new RowSezione("Udienze",udienzeEsiti) : new RowSezione(null,null),
          new RowSezione('Prossima udienza', [
            // new VoceSezione(4, 'date', 'Ultima udienza', fascicolo.copertina.campi.ultimaUdienza),
            new VoceSezione(6, 'text', 'Adempimento', fascicolo.copertina.campi.prossimaUdienzaTipoAdempimento),
            new VoceSezione(6, 'date', 'Prossima udienza', fascicolo.copertina.campi.prossimaUdienza),
            // new VoceSezione(4, 'date', 'Prossima scadenza', fascicolo.copertina.campi.prossimaScadenza)
          ]),
          new RowSezione('Competenze ', [
            new VoceSezione(12, 'text', 'Gruppi competenti', fascicolo.copertina.campi.competenza)
          ]),
        ];
        break;
      }
      case 'precetto': {
        return [new RowSezione(null, [
          new VoceSezione(3, 'text', 'Posizione', fascicolo.copertina.campi.identificativoFascicolo),
          new VoceSezione(3, 'text', 'Vecchia posizione', fascicolo.vecchiaPosizione),
          new VoceSezione(3, 'text', 'Tipo Fascicolo', fascicolo.copertina.campi.tipo),
          new VoceSezione(3, 'text', 'Stato', fascicolo.copertina.campi.stato)
        ]),
          new RowSezione(null, [
            new VoceSezione(3, 'text', 'Natura', fascicolo.copertina.campi.natura),
            new VoceSezione(3, 'text', 'Parti', fascicolo.copertina.campi.parti),
            new VoceSezione(3, 'text', 'Assegnatario', assegnatario),
            new VoceSezione(3, 'text', 'Legale di controparte', fascicolo.copertina.campi.legaliControparti)
          ]),
          new RowSezione(null, [
            new VoceSezione(12, 'text', 'Fondo rischi SI/NO', true === fascicolo.copertina.campi.fondoRischi ? 'Si' : 'No'),
          ]),
          new RowSezione(null, [
            new VoceSezione(12, 'textarea', 'Descrizione oggetto', fascicolo.descrizioneOggetto),
          ]),
          new RowSezione(null, [
            new VoceSezione(6, 'date', 'Data apertura fascicolo', fascicolo.copertina.campi.dataInizioFascicolo),
            new VoceSezione(6, 'date', 'Data notifica', fascicolo.dataNotifica)
          ]),
          new RowSezione(null, [
            // new VoceSezione(4, 'text', 'Numero/anno ruolo', (fascicolo.copertina.campi.numeroRuolo ? fascicolo.copertina.campi.numeroRuolo : '') + (fascicolo.copertina.campi.numeroRuolo && fascicolo.copertina.campi.annoRuolo ? '/' : '') + (fascicolo.copertina.campi.annoRuolo ? fascicolo.copertina.campi.annoRuolo : '')),
            new VoceSezione(4, 'text', 'Numero decreto ingiuntivo riferimento', fascicolo.copertina.campi.numeroDecretoIngiuntivoRif),
            new VoceSezione(4, 'importo', 'Valore decreto ingiuntivo riferimento', fascicolo.copertina.campi.valoreDecretoIngiuntivoRif)
          ]),
          new RowSezione(((fascicolo.copertina.campi.capofila || fascicolo.copertina.campi.riunito) ? 'Riunione dei giudizi' : ''), (fascicolo.copertina.campi.capofila || fascicolo.copertina.campi.riunito) ? [
            new VoceSezione(4, 'text', fascicolo.copertina.campi.capofila ? 'Capofila' : 'Riunito', 'Si'),
            new VoceSezione(4, 'date', 'Data riunione giudizio', fascicolo.copertina.campi.dataRiunioneGiudizio),
            new VoceSezione(4, 'text', 'Motivo riunione giudizio', fascicolo.copertina.campi.motivoRiunioneGiudizio)
          ] : [new VoceSezione(12, '', '', '')]),
          esiti.length > 0 ? new RowSezione("Esiti",esiti) : new RowSezione(null, null),
          udienzeEsiti.length > 0 ? new RowSezione("Udienze",udienzeEsiti) : new RowSezione(null,null),
          new RowSezione('Prossima udienza', [
            // new VoceSezione(4, 'date', 'Ultima udienza', fascicolo.copertina.campi.ultimaUdienza),
            new VoceSezione(6, 'text', 'Adempimento', fascicolo.copertina.campi.prossimaUdienzaTipoAdempimento),
            new VoceSezione(6, 'date', 'Prossima udienza', fascicolo.copertina.campi.prossimaUdienza),
            // new VoceSezione(4, 'date', 'Prossima scadenza', fascicolo.copertina.campi.prossimaScadenza)
          ]),
          new RowSezione('Competenze ', [
            new VoceSezione(12, 'text', 'Gruppi competenti', fascicolo.copertina.campi.competenza)
          ]),
        ];
        break;
      }
      case 'arbitrato': {
        return [new RowSezione(null, [
          new VoceSezione(3, 'text', 'Posizione', fascicolo.copertina.campi.identificativoFascicolo),
          new VoceSezione(3, 'text', 'Vecchia posizione', fascicolo.vecchiaPosizione),
          new VoceSezione(3, 'text', 'Tipo Fascicolo', fascicolo.copertina.campi.tipo),
          new VoceSezione(3, 'text', 'Stato', fascicolo.copertina.campi.stato)
        ]),
          new RowSezione(null, [
            new VoceSezione(3, 'text', 'Natura', fascicolo.copertina.campi.natura),
            new VoceSezione(3, 'text', 'Parti', fascicolo.copertina.campi.parti),
            new VoceSezione(3, 'text', 'Assegnatario', assegnatario),
            new VoceSezione(3, 'text', 'Legale di controparte', fascicolo.copertina.campi.legaliControparti)
          ]),
          new RowSezione(null, [
            new VoceSezione(12, 'text', 'Fondo rischi SI/NO', true === fascicolo.copertina.campi.fondoRischi ? 'Si' : 'No'),
          ]),
          new RowSezione(null, [
            new VoceSezione(12, 'textarea', 'Descrizione oggetto', fascicolo.descrizioneOggetto),
          ]),
          new RowSezione(null, [
            new VoceSezione(6, 'date', 'Data apertura fascicolo', fascicolo.copertina.campi.dataInizioFascicolo),
            new VoceSezione(6, 'date', 'Data notifica', fascicolo.dataNotifica)
          ]),
          esiti.length > 0 ? new RowSezione("Esiti",esiti) : new RowSezione(null, null),
          udienzeEsiti.length > 0 ? new RowSezione("Udienze",udienzeEsiti) : new RowSezione(null,null),
          new RowSezione('Prossima udienza', [
            // new VoceSezione(4, 'date', 'Ultima udienza', fascicolo.copertina.campi.ultimaUdienza),
            new VoceSezione(6, 'text', 'Adempimento', fascicolo.copertina.campi.prossimaUdienzaTipoAdempimento),
            new VoceSezione(6, 'date', 'Prossima udienza', fascicolo.copertina.campi.prossimaUdienza),
            // new VoceSezione(4, 'date', 'Prossima scadenza', fascicolo.copertina.campi.prossimaScadenza)
          ]),
          new RowSezione('Arbitri - Collegio arbitrale', [
            new VoceSezione(12, 'text', 'Arbitri', fascicolo.copertina.campi.listaArbitri)
          ]),
          new RowSezione('Competenze ', [
            new VoceSezione(12, 'text', 'Gruppi competenti', fascicolo.copertina.campi.competenza)
          ]),
        ];
        break;
      }
      case 'mediazione': {
        return [new RowSezione(null, [
          new VoceSezione(3, 'text', 'Posizione', fascicolo.copertina.campi.identificativoFascicolo),
          new VoceSezione(3, 'text', 'Vecchia posizione', fascicolo.vecchiaPosizione),
          new VoceSezione(3, 'text', 'Tipo Fascicolo', fascicolo.copertina.campi.tipo),
          new VoceSezione(3, 'text', 'Stato', fascicolo.copertina.campi.stato)
        ]),
          new RowSezione(null, [
            new VoceSezione(3, 'text', 'Natura', fascicolo.copertina.campi.natura),
            new VoceSezione(3, 'text', 'Parti', fascicolo.copertina.campi.parti),
            new VoceSezione(3, 'text', 'Assegnatario', assegnatario),
            new VoceSezione(3, 'text', 'Legale di controparte', fascicolo.copertina.campi.legaliControparti)
          ]),
          new RowSezione(null, [
            new VoceSezione(12, 'text', 'Fondo rischi SI/NO', true === fascicolo.copertina.campi.fondoRischi ? 'Si' : 'No'),
          ]),
          new RowSezione(null, [
            new VoceSezione(12, 'textarea', 'Descrizione oggetto', fascicolo.descrizioneOggetto),
          ]),
          new RowSezione(null, [
            new VoceSezione(6, 'date', 'Data apertura fascicolo', fascicolo.copertina.campi.dataInizioFascicolo),
            new VoceSezione(6, 'date', 'Data notifica', fascicolo.dataNotifica)
          ]),
          new RowSezione(null, [
            new VoceSezione(6, 'text', 'Organismo di mediazione', fascicolo.copertina.campi.organismoMediazione),
            new VoceSezione(6, 'text', 'Sede mediazione', fascicolo.copertina.campi.sedeIncontro),
            //new VoceSezione(4, 'boolean', 'Fondo rischi', fascicolo.copertina.campi.fondoRischi)
          ]),
          esiti.length > 0 ? new RowSezione("Esiti",esiti) : new RowSezione(null, null),
          udienzeEsiti.length > 0 ? new RowSezione("Udienze",udienzeEsiti) : new RowSezione(null,null),
          new RowSezione('Prossima udienza', [
            // new VoceSezione(4, 'date', 'Ultima udienza', fascicolo.copertina.campi.ultimaUdienza),
            new VoceSezione(6, 'text', 'Adempimento', fascicolo.copertina.campi.prossimaUdienzaTipoAdempimento),
            new VoceSezione(6, 'date', 'Prossima udienza', fascicolo.copertina.campi.prossimaUdienza),
            // new VoceSezione(4, 'date', 'Prossima scadenza', fascicolo.copertina.campi.prossimaScadenza)
          ]),
          new RowSezione('Competenze ', [
            new VoceSezione(12, 'text', 'Gruppi competenti', fascicolo.copertina.campi.competenza)
          ]),
        ];
        break;
      }
      case 'recuperocreditistragiudiziale': {
        return [new RowSezione(null, [
          new VoceSezione(3, 'text', 'Posizione', fascicolo.copertina.campi.identificativoFascicolo),
          new VoceSezione(3, 'text', 'Vecchia posizione', fascicolo.vecchiaPosizione),
          new VoceSezione(3, 'text', 'Tipo Fascicolo', fascicolo.copertina.campi.tipo),
          new VoceSezione(3, 'text', 'Stato', fascicolo.copertina.campi.stato)
        ]),
          new RowSezione(null, [
            new VoceSezione(3, 'text', 'Natura', fascicolo.copertina.campi.natura),
            new VoceSezione(3, 'text', 'Parti', fascicolo.copertina.campi.parti),
            new VoceSezione(3, 'text', 'Assegnatario', assegnatario),
            new VoceSezione(3, 'text', 'Legale di controparte', fascicolo.copertina.campi.legaliControparti)
          ]),
          new RowSezione(null, [
            new VoceSezione(12, 'text', 'Fondo rischi SI/NO', true === fascicolo.copertina.campi.fondoRischi ? 'Si' : 'No'),
          ]),
          new RowSezione(null, [
            new VoceSezione(12, 'textarea', 'Descrizione oggetto', fascicolo.descrizioneOggetto),
          ]),
          new RowSezione(null, [
            new VoceSezione(6, 'date', 'Data apertura fascicolo', fascicolo.copertina.campi.dataInizioFascicolo),
            new VoceSezione(6, 'date', 'Data notifica', fascicolo.dataNotifica)
          ]),
          new RowSezione('Diffida', [
            new VoceSezione(4, 'text', 'Ultima lettera diffida (numero invii)',
              (fascicolo.copertina.campi.tipoUltimaLetteraDiffida ? (fascicolo.copertina.campi.tipoUltimaLetteraDiffida +
                ' (' + (fascicolo.copertina.campi.numeroInviiDiffida ? fascicolo.copertina.campi.numeroInviiDiffida : '0') + ')') : '')),
            new VoceSezione(4, 'date', 'Data ultima diffida', fascicolo.copertina.campi.dataUltimaLetteraDiffida),
            new VoceSezione(4, 'text', 'Esito ultimo invio', fascicolo.copertina.campi.esitoUltimoInvioDiffida)
          ]),
          esiti.length > 0 ? new RowSezione("Esiti",esiti) : new RowSezione(null, null),
          udienzeEsiti.length > 0 ? new RowSezione("Udienze",udienzeEsiti) : new RowSezione(null,null),
          new RowSezione('Prossima udienza', [
            // new VoceSezione(4, 'date', 'Ultima udienza', fascicolo.copertina.campi.ultimaUdienza),
            new VoceSezione(6, 'text', 'Adempimento', fascicolo.copertina.campi.prossimaUdienzaTipoAdempimento),
            new VoceSezione(6, 'date', 'Prossima udienza', fascicolo.copertina.campi.prossimaUdienza),
            // new VoceSezione(4, 'date', 'Prossima scadenza', fascicolo.copertina.campi.prossimaScadenza)
          ]),
          new RowSezione('Competenze ', [
            new VoceSezione(12, 'text', 'Gruppi competenti', fascicolo.copertina.campi.competenza)
          ]),
        ];
        break;
      }
      case 'sinistrosanitario': {
        return [new RowSezione(null, [
          new VoceSezione(3, 'text', 'Posizione', fascicolo.copertina.campi.identificativoFascicolo),
          new VoceSezione(3, 'text', 'Vecchia posizione', fascicolo.vecchiaPosizione),
          new VoceSezione(3, 'text', 'Tipo Fascicolo', fascicolo.copertina.campi.tipo),
          new VoceSezione(3, 'text', 'Natura', fascicolo.copertina.campi.natura)
        ]),
          new RowSezione(null, [
            new VoceSezione(12, 'textarea', 'Descrizione oggetto', fascicolo.descrizioneOggetto),
          ]),
          new RowSezione(null, [
            new VoceSezione(4, 'date', 'Data inizio fascicolo', fascicolo.copertina.campi.dataInizioFascicolo),
            new VoceSezione(4, 'date', 'Data ultima modifica', fascicolo.copertina.campi.dataUltimaModifica),
            new VoceSezione(4, 'text', 'Stato', fascicolo.copertina.campi.stato)
          ]),
          new RowSezione(null, [
            new VoceSezione(4, 'date', 'Data definizione', fascicolo.copertina.campi.dataDefinizione),
            new VoceSezione(4, 'text', 'Motivo definizione', fascicolo.copertina.campi.motivoDefinizione),
            // new VoceSezione(2, 'boolean', 'Fondo rischi', fascicolo.copertina.campi.fondoRischi),
            // new VoceSezione(2, 'text', 'Valore', fascicolo.copertina.campi.valore)
          ]),
          new RowSezione(null, [
            new VoceSezione(4, 'text', 'Controparte primaria (n. controparti)', (fascicolo.copertina.campi.contropartePrimaria) + (' (' + fascicolo.copertina.campi.numeroControparti + ')')),
            new VoceSezione(4, 'text', 'Legale incaricato', (fascicolo.copertina.campi.legaleIncaricato ? fascicolo.copertina.campi.legaleIncaricato : '') + (fascicolo.copertina.campi.tipologiaDiLegaleIncaricato ? ' (' + fascicolo.copertina.campi.tipologiaDiLegaleIncaricato + ')' : '')),
            new VoceSezione(4, 'text', 'Assegnatario', fascicolo.copertina.campi.assegnatario),
            new VoceSezione(4, 'text', 'Visibilità', fascicolo.tipoVisibilita?.label ? fascicolo.tipoVisibilita?.label : (fascicolo.praticaBase.tipoVisibilita?.label ? fascicolo.praticaBase.tipoVisibilita?.label : null))

          ]),
          new RowSezione('Diffida', [
            new VoceSezione(4, 'text', 'Ultima lettera diffida (numero invii)',
              (fascicolo.copertina.campi.tipoUltimaLetteraDiffida ? (fascicolo.copertina.campi.tipoUltimaLetteraDiffida +
                ' (' + (fascicolo.copertina.campi.numeroInviiDiffida ? fascicolo.copertina.campi.numeroInviiDiffida : '0') + ')') : '')),
            new VoceSezione(4, 'date', 'Data ultima diffida', fascicolo.copertina.campi.dataUltimaLetteraDiffida),
            new VoceSezione(4, 'text', 'Esito ultimo invio', fascicolo.copertina.campi.esitoUltimoInvioDiffida)
          ]),
          esiti.length > 0 ? new RowSezione("Esiti",esiti) : new RowSezione(null, null),
          udienzeEsiti.length > 0 ? new RowSezione("Udienze",udienzeEsiti) : new RowSezione(null,null),
          new RowSezione('Prossima udienza', [
            //new VoceSezione(4, 'date', 'Ultima udienza', fascicolo.copertina.campi.ultimaUdienza),
            new VoceSezione(6, 'text', 'Adempimento', fascicolo.copertina.campi.prossimaUdienzaTipoAdempimento),
            new VoceSezione(6, 'date', 'Prossima udienza', fascicolo.copertina.campi.prossimaUdienza),
            //new VoceSezione(4, 'date', 'Prossima scadenza', fascicolo.copertina.campi.prossimaScadenza)
          ]),
          new RowSezione('Competenza', [
            new VoceSezione(12, 'text', 'Gruppi competenti', fascicolo.copertina.campi.competenza)
          ]),
        ];
        break;
      }
      case 'negoziazione': {
        return [new RowSezione(null, [
          new VoceSezione(3, 'text', 'Posizione', fascicolo.copertina.campi.identificativoFascicolo),
          new VoceSezione(3, 'text', 'Vecchia posizione', fascicolo.vecchiaPosizione),
          new VoceSezione(3, 'text', 'Tipo Fascicolo', fascicolo.copertina.campi.tipo),
          new VoceSezione(3, 'text', 'Stato', fascicolo.copertina.campi.stato)
        ]),
          new RowSezione(null, [
            new VoceSezione(3, 'text', 'Natura', fascicolo.copertina.campi.natura),
            new VoceSezione(3, 'text', 'Parti', fascicolo.copertina.campi.parti),
            new VoceSezione(3, 'text', 'Assegnatario', assegnatario),
            new VoceSezione(3, 'text', 'Legale di controparte', fascicolo.copertina.campi.legaliControparti)
          ]),
          new RowSezione(null, [
            new VoceSezione(12, 'text', 'Fondo rischi SI/NO', true === fascicolo.copertina.campi.fondoRischi ? 'Si' : 'No'),
          ]),
          new RowSezione(null, [
            new VoceSezione(12, 'textarea', 'Descrizione oggetto', fascicolo.descrizioneOggetto),
          ]),
          new RowSezione(null, [
            new VoceSezione(6, 'date', 'Data apertura fascicolo', fascicolo.copertina.campi.dataInizioFascicolo),
            new VoceSezione(6, 'date', 'Data notifica', fascicolo.dataNotifica)
          ]),
          new RowSezione(null, [
            new VoceSezione(4, 'text', 'Costituzione SI/NO', true === fascicolo.flagCostituzione ? 'Si' : 'No'),
            new VoceSezione(4, 'text', 'Motivazione', fascicolo.motivazione ? fascicolo.motivazione.label : ''),
            new VoceSezione(4, 'date', 'Data costituzione', fascicolo.dataCostituzione)
          ]),
          new RowSezione('Negoziazione', [
            new VoceSezione(4, 'text', 'Tipo negoziazione', fascicolo.copertina.campi.tipoNegoziazione),
            new VoceSezione(4, 'date', 'Data invio invito', fascicolo.copertina.campi.dataInvito),
            new VoceSezione(4, 'date', 'Data termine concordato', fascicolo.copertina.campi.dataTermineConcordato)
          ]),
          esiti.length > 0 ? new RowSezione("Esiti",esiti) : new RowSezione(null, null),
          udienzeEsiti.length > 0 ? new RowSezione("Udienze",udienzeEsiti) : new RowSezione(null,null),
          new RowSezione('Prossima udienza', [
            // new VoceSezione(4, 'date', 'Ultima udienza', fascicolo.copertina.campi.ultimaUdienza),
            new VoceSezione(6, 'text', 'Adempimento', fascicolo.copertina.campi.prossimaUdienzaTipoAdempimento),
            new VoceSezione(6, 'date', 'Prossima udienza', fascicolo.copertina.campi.prossimaUdienza),
            // new VoceSezione(4, 'date', 'Prossima scadenza', fascicolo.copertina.campi.prossimaScadenza)
          ]),
          new RowSezione('Competenze ', [
            new VoceSezione(12, 'text', 'Gruppi competenti', fascicolo.copertina.campi.competenza)
          ]),
        ];
        break;
      }
      case 'amianto': {
        return [new RowSezione(null, [
          new VoceSezione(3, 'text', 'Posizione', fascicolo.copertina.campi.identificativoFascicolo),
          new VoceSezione(3, 'text', 'Vecchia posizione', fascicolo.vecchiaPosizione),
          new VoceSezione(3, 'text', 'Tipo Fascicolo', fascicolo.copertina.campi.tipo),
          new VoceSezione(3, 'text', 'Natura', fascicolo.copertina.campi.natura)
        ]),
          new RowSezione(null, [
            new VoceSezione(12, 'textarea', 'Descrizione oggetto', fascicolo.descrizioneOggetto),
          ]),
          new RowSezione(null, [
            new VoceSezione(4, 'date', 'Data apertura fascicolo', fascicolo.copertina.campi.dataInizioFascicolo),
            new VoceSezione(4, 'date', 'Data ultima modifica', fascicolo.copertina.campi.dataUltimaModifica),
            new VoceSezione(4, 'text', 'Stato', fascicolo.copertina.campi.stato)
          ]),
          new RowSezione(null, [
            new VoceSezione(6, 'date', 'Data definizione', fascicolo.copertina.campi.dataDefinizione),
            new VoceSezione(6, 'text', 'Motivo definizione', fascicolo.copertina.campi.motivoDefinizione),
            // new VoceSezione(4, 'boolean', 'Fondo rischi', fascicolo.copertina.campi.fondoRischi)
          ]),
          new RowSezione(((fascicolo.copertina.campi.capofila || fascicolo.copertina.campi.riunito) ? 'Riunione dei giudizi' : ''), (fascicolo.copertina.campi.capofila || fascicolo.copertina.campi.riunito) ? [
            new VoceSezione(4, 'text', fascicolo.copertina.campi.capofila ? 'Capofila' : 'Riunito', 'Si'),
            new VoceSezione(4, 'date', 'Data riunione giudizio', fascicolo.copertina.campi.dataRiunioneGiudizio),
            new VoceSezione(4, 'text', 'Motivo riunione giudizio', fascicolo.copertina.campi.motivoRiunioneGiudizio)
          ] : [new VoceSezione(12, '', '', '')]),
          new RowSezione(null, [
            new VoceSezione(4, 'text', 'Parte primaria (n. controparti)', (fascicolo.copertina.campi.contropartePrimaria) + (' (' + fascicolo.copertina.campi.numeroControparti + ')')),
            //new VoceSezione(4, 'text', 'Legale incaricato', (fascicolo.copertina.campi.legaleIncaricato ? fascicolo.copertina.campi.legaleIncaricato : '') + (fascicolo.copertina.campi.tipologiaDiLegaleIncaricato ? ' (' + fascicolo.copertina.campi.tipologiaDiLegaleIncaricato + ')' : '')),
            new VoceSezione(4, 'text', 'Assegnatario', assegnatario),
            new VoceSezione(4, 'text', 'Visibilità', fascicolo.tipoVisibilita?.label ? fascicolo.tipoVisibilita?.label : (fascicolo.praticaBase.tipoVisibilita?.label ? fascicolo.praticaBase.tipoVisibilita?.label : null))
          ]),
          /*new RowSezione(null, [
            new VoceSezione(4, 'text', 'Numero/anno ruolo', (fascicolo.copertina.campi.numeroRuolo ? fascicolo.copertina.campi.numeroRuolo : '') + (fascicolo.copertina.campi.numeroRuolo && fascicolo.copertina.campi.annoRuolo ? '/' : '') + (fascicolo.copertina.campi.annoRuolo ? fascicolo.copertina.campi.annoRuolo : '')),
            new VoceSezione(4, 'text', 'Autorit&agrave; giudiziaria', (fascicolo.copertina.campi.autoritaGiudiziaria ? fascicolo.copertina.campi.autoritaGiudiziaria : '') + (fascicolo.copertina.campi.sedeAutoritaGiudiziaria != null ? ' di ' + (fascicolo.copertina.campi.sedeAutoritaGiudiziaria) : '')),
            new VoceSezione(4, 'text', 'Valore', fascicolo.copertina.campi.valore)
          ]),*/
          esiti.length > 0 ? new RowSezione("Esiti",esiti) : new RowSezione(null, null),
          udienzeEsiti.length > 0 ? new RowSezione("Udienze",udienzeEsiti) : new RowSezione(null,null),
          new RowSezione('Prossima udienza', [
            // new VoceSezione(4, 'date', 'Ultima udienza', fascicolo.copertina.campi.ultimaUdienza),
            new VoceSezione(6, 'text', 'Adempimento', fascicolo.copertina.campi.prossimaUdienzaTipoAdempimento),
            new VoceSezione(6, 'date', 'Prossima udienza', fascicolo.copertina.campi.prossimaUdienza),
            // new VoceSezione(4, 'date', 'Prossima scadenza', fascicolo.copertina.campi.prossimaScadenza)
          ]),
          new RowSezione('Competenze ', [
            new VoceSezione(12, 'text', 'Gruppi competenti', fascicolo.copertina.campi.competenza)
          ]),
        ];
        break;
      }
      case 'amiantogiudiziale': {
        return [new RowSezione(null, [
          new VoceSezione(3, 'text', 'Posizione', fascicolo.copertina.campi.identificativoFascicolo),
          new VoceSezione(3, 'text', 'Vecchia posizione', fascicolo.vecchiaPosizione),
          new VoceSezione(3, 'text', 'Tipo Fascicolo', fascicolo.copertina.campi.tipo),
          new VoceSezione(3, 'text', 'Natura', fascicolo.copertina.campi.natura)
        ]),
          new RowSezione(null, [
            new VoceSezione(12, 'textarea', 'Descrizione oggetto', fascicolo.descrizioneOggetto),
          ]),
          new RowSezione(null, [
            new VoceSezione(4, 'date', 'Data apertura fascicolo', fascicolo.copertina.campi.dataInizioFascicolo),
            new VoceSezione(4, 'date', 'Data ultima modifica', fascicolo.copertina.campi.dataUltimaModifica),
            new VoceSezione(4, 'text', 'Stato', fascicolo.copertina.campi.stato)
          ]),
          new RowSezione(null, [
            new VoceSezione(6, 'date', 'Data definizione', fascicolo.copertina.campi.dataDefinizione),
            new VoceSezione(6, 'text', 'Motivo definizione', fascicolo.copertina.campi.motivoDefinizione),
            //new VoceSezione(4, 'boolean', 'Fondo rischi', fascicolo.copertina.campi.fondoRischi)
          ]),
          new RowSezione(((fascicolo.copertina.campi.capofila || fascicolo.copertina.campi.riunito) ? 'Riunione dei giudizi' : ''), (fascicolo.copertina.campi.capofila || fascicolo.copertina.campi.riunito) ? [
            new VoceSezione(4, 'text', fascicolo.copertina.campi.capofila ? 'Capofila' : 'Riunito', 'Si'),
            new VoceSezione(4, 'date', 'Data riunione giudizio', fascicolo.copertina.campi.dataRiunioneGiudizio),
            new VoceSezione(4, 'text', 'Motivo riunione giudizio', fascicolo.copertina.campi.motivoRiunioneGiudizio)
          ] : [new VoceSezione(12, '', '', '')]),
          new RowSezione(null, [
            new VoceSezione(4, 'text', 'Parte primaria (n. controparti)', (fascicolo.copertina.campi.contropartePrimaria) + (' (' + fascicolo.copertina.campi.numeroControparti + ')')),
            //new VoceSezione(4, 'text', 'Legale incaricato', (fascicolo.copertina.campi.legaleIncaricato ? fascicolo.copertina.campi.legaleIncaricato : '') + (fascicolo.copertina.campi.tipologiaDiLegaleIncaricato ? ' (' + fascicolo.copertina.campi.tipologiaDiLegaleIncaricato + ')' : '')),
            new VoceSezione(4, 'text', 'Assegnatario', assegnatario),
            new VoceSezione(4, 'text', 'Visibilità', fascicolo.tipoVisibilita?.label ? fascicolo.tipoVisibilita?.label : (fascicolo.praticaBase.tipoVisibilita?.label ? fascicolo.praticaBase.tipoVisibilita?.label : null))
          ]),
          new RowSezione(null, [
            new VoceSezione(4, 'text', 'Numero/anno ruolo', (fascicolo.copertina.campi.numeroRuolo ? fascicolo.copertina.campi.numeroRuolo : '') + (fascicolo.copertina.campi.numeroRuolo && fascicolo.copertina.campi.annoRuolo ? '/' : '') + (fascicolo.copertina.campi.annoRuolo ? fascicolo.copertina.campi.annoRuolo : '')),
            new VoceSezione(4, 'text', 'Autorit&agrave; giudiziaria', (fascicolo.copertina.campi.autoritaGiudiziaria ? fascicolo.copertina.campi.autoritaGiudiziaria : '') + (fascicolo.copertina.campi.sedeAutoritaGiudiziaria != null ? ' di ' + (fascicolo.copertina.campi.sedeAutoritaGiudiziaria) : '')),
            new VoceSezione(4, 'text', 'Valore', fascicolo.copertina.campi.valore)
          ]),
          esiti.length > 0 ? new RowSezione("Esiti",esiti) : new RowSezione(null, null),
          udienzeEsiti.length > 0 ? new RowSezione("Udienze",udienzeEsiti) : new RowSezione(null,null),
          new RowSezione('Prossima udienza', [
            // new VoceSezione(4, 'date', 'Ultima udienza', fascicolo.copertina.campi.ultimaUdienza),
            new VoceSezione(6, 'text', 'Adempimento', fascicolo.copertina.campi.prossimaUdienzaTipoAdempimento),
            new VoceSezione(6, 'date', 'Prossima udienza', fascicolo.copertina.campi.prossimaUdienza),
            // new VoceSezione(4, 'date', 'Prossima scadenza', fascicolo.copertina.campi.prossimaScadenza)
          ]),
          new RowSezione('Competenze ', [
            new VoceSezione(12, 'text', 'Gruppi competenti', fascicolo.copertina.campi.competenza)
          ]),
        ];
        break;
      }
      case 'ricorso':
      case 'ricorsolavoro': {
        return [new RowSezione(null, [
          new VoceSezione(3, 'text', 'Posizione', fascicolo.copertina.campi.identificativoFascicolo),
          new VoceSezione(3, 'text', 'Vecchia posizione', fascicolo.vecchiaPosizione),
          new VoceSezione(3, 'text', 'Tipo Fascicolo', fascicolo.copertina.campi.tipo),
          new VoceSezione(3, 'text', 'Stato', fascicolo.copertina.campi.stato)
        ]),
          new RowSezione(null, [
            new VoceSezione(3, 'text', 'Natura', fascicolo.copertina.campi.natura),
            new VoceSezione(3, 'text', 'Parti', fascicolo.copertina.campi.parti),
            new VoceSezione(3, 'text', 'Assegnatario', assegnatario),
            new VoceSezione(3, 'text', 'Legale di controparte', fascicolo.copertina.campi.legaliControparti)
          ]),
          new RowSezione(null, [
            new VoceSezione(12, 'text', 'Fondo rischi SI/NO', true === fascicolo.copertina.campi.fondoRischi ? 'Si' : 'No'),
          ]),
          new RowSezione('Dati Giudiziari', [
            new VoceSezione(4, 'text', 'Autorit&agrave; giudiziaria', (fascicolo.copertina.campi.autoritaGiudiziaria ? fascicolo.copertina.campi.autoritaGiudiziaria : '')),
            new VoceSezione(4, 'text', 'Sede', fascicolo.copertina.campi.sedeAutoritaGiudiziaria),
            new VoceSezione(4, 'text', 'Grado', (fascicolo.copertina.campi.grado ? fascicolo.copertina.campi.grado : '')),
            new VoceSezione(6, 'text', 'Numero/anno ruolo', (fascicolo.copertina.campi.numeroRuolo ? fascicolo.copertina.campi.numeroRuolo : '') + (fascicolo.copertina.campi.numeroRuolo && fascicolo.copertina.campi.annoRuolo ? '/' : '') + (fascicolo.copertina.campi.annoRuolo ? fascicolo.copertina.campi.annoRuolo : '')),
            new VoceSezione(6, 'text', 'Sezione', fascicolo.copertina.campi.sezione)
          ]),
          new RowSezione(null, [
            new VoceSezione(12, 'textarea', 'Descrizione oggetto', fascicolo.descrizioneOggetto),
          ]),
          new RowSezione(null, [
            new VoceSezione(4, 'date', 'Data apertura fascicolo', fascicolo.copertina.campi.dataInizioFascicolo),
            new VoceSezione(4, 'date', 'Data notifica', fascicolo.dataNotifica),
            new VoceSezione(4, 'date', 'Data prima comparizione', fascicolo.dataPrimaComparizione)
          ]),
          new RowSezione(null, [
            new VoceSezione(4, 'text', 'Costituzione SI/NO', true === fascicolo.flagCostituzione ? 'Si' : 'No'),
            new VoceSezione(4, 'text', 'Motivazione', fascicolo.motivazione ? fascicolo.motivazione.label : ''),
            new VoceSezione(4, 'date', 'Data costituzione', fascicolo.dataCostituzione)
          ]),
          new RowSezione(((fascicolo.copertina.campi.capofila || fascicolo.copertina.campi.riunito) ? 'Riunione dei giudizi' : ''), (fascicolo.copertina.campi.capofila || fascicolo.copertina.campi.riunito) ? [
            new VoceSezione(4, 'text', fascicolo.copertina.campi.capofila ? 'Capofila' : 'Riunito', 'Si'),
            new VoceSezione(4, 'date', 'Data riunione giudizio', fascicolo.copertina.campi.dataRiunioneGiudizio),
            new VoceSezione(4, 'text', 'Motivo riunione giudizio', fascicolo.copertina.campi.motivoRiunioneGiudizio)
          ] : [new VoceSezione(12, '', '', '')]),
          esiti.length > 0 ? new RowSezione("Esiti",esiti) : new RowSezione(null, null),
          udienzeEsiti.length > 0 ? new RowSezione("Udienze",udienzeEsiti) : new RowSezione(null,null),
          new RowSezione('Prossima udienza', [
            // new VoceSezione(4, 'date', 'Ultima udienza', fascicolo.copertina.campi.ultimaUdienza),
            new VoceSezione(6, 'text', 'Adempimento', fascicolo.copertina.campi.prossimaUdienzaTipoAdempimento),
            new VoceSezione(6, 'date', 'Prossima udienza', fascicolo.copertina.campi.prossimaUdienza),
            // new VoceSezione(4, 'date', 'Prossima scadenza', fascicolo.copertina.campi.prossimaScadenza)
          ]),
          new RowSezione('Competenze ', [
            new VoceSezione(12, 'text', 'Gruppi competenti', fascicolo.copertina.campi.competenza)
          ]),
        ];
        break;
      }
      case 'esecuzione': {
        return [new RowSezione(null, [
          new VoceSezione(3, 'text', 'Posizione', fascicolo.copertina.campi.identificativoFascicolo),
          new VoceSezione(3, 'text', 'Vecchia posizione', fascicolo.vecchiaPosizione),
          new VoceSezione(3, 'text', 'Tipo Fascicolo', fascicolo.copertina.campi.tipo),
          new VoceSezione(3, 'text', 'Natura', fascicolo.copertina.campi.natura)
        ]),
          new RowSezione(null, [
            new VoceSezione(12, 'textarea', 'Descrizione oggetto', fascicolo.descrizioneOggetto),
          ]),
          new RowSezione(null, [
            new VoceSezione(4, 'date', 'Data apertura fascicolo', fascicolo.copertina.campi.dataInizioFascicolo),
            new VoceSezione(4, 'date', 'Data ultima modifica', fascicolo.copertina.campi.dataUltimaModifica),
            new VoceSezione(4, 'text', 'Stato', fascicolo.copertina.campi.stato)
          ]),
          new RowSezione(null, [
            new VoceSezione(6, 'date', 'Data definizione', fascicolo.copertina.campi.dataDefinizione),
            new VoceSezione(6, 'text', 'Motivo definizione', fascicolo.copertina.campi.motivoDefinizione),
            //new VoceSezione(4, 'boolean', 'Fondo rischi', fascicolo.copertina.campi.fondoRischi)
          ]),
          new RowSezione(((fascicolo.copertina.campi.capofila || fascicolo.copertina.campi.riunito) ? 'Riunione dei giudizi' : ''), (fascicolo.copertina.campi.capofila || fascicolo.copertina.campi.riunito) ? [
            new VoceSezione(4, 'text', fascicolo.copertina.campi.capofila ? 'Capofila' : 'Riunito', 'Si'),
            new VoceSezione(4, 'date', 'Data riunione giudizio', fascicolo.copertina.campi.dataRiunioneGiudizio),
            new VoceSezione(4, 'text', 'Motivo riunione giudizio', fascicolo.copertina.campi.motivoRiunioneGiudizio)
          ] : [new VoceSezione(12, '', '', '')]),
          new RowSezione(null, [
            new VoceSezione(4, 'text', 'Parte primaria (n. controparti)', (fascicolo.copertina.campi.contropartePrimaria) + (' (' + fascicolo.copertina.campi.numeroControparti + ')')),
            //new VoceSezione(4, 'text', 'Legale incaricato', (fascicolo.copertina.campi.legaleIncaricato ? fascicolo.copertina.campi.legaleIncaricato : '') + (fascicolo.copertina.campi.tipologiaDiLegaleIncaricato ? ' (' + fascicolo.copertina.campi.tipologiaDiLegaleIncaricato + ')' : '')),
            new VoceSezione(4, 'text', 'Assegnatario', assegnatario),
            new VoceSezione(4, 'text', 'Visibilità', fascicolo.tipoVisibilita?.label ? fascicolo.tipoVisibilita?.label : (fascicolo.praticaBase.tipoVisibilita?.label ? fascicolo.praticaBase.tipoVisibilita?.label : null))
          ]),
          new RowSezione(null, [
            new VoceSezione(4, 'text', 'Numero/anno ruolo', (fascicolo.copertina.campi.numeroRuolo ? fascicolo.copertina.campi.numeroRuolo : '') + (fascicolo.copertina.campi.numeroRuolo && fascicolo.copertina.campi.annoRuolo ? '/' : '') + (fascicolo.copertina.campi.annoRuolo ? fascicolo.copertina.campi.annoRuolo : '')),
            new VoceSezione(4, 'text', 'Autorit&agrave; giudiziaria', (fascicolo.copertina.campi.autoritaGiudiziaria ? fascicolo.copertina.campi.autoritaGiudiziaria : '') + (fascicolo.copertina.campi.sedeAutoritaGiudiziaria != null ? ' di ' + (fascicolo.copertina.campi.sedeAutoritaGiudiziaria) : '')),
            new VoceSezione(4, 'text', 'Valore', fascicolo.copertina.campi.valore)
          ]),
          esiti.length > 0 ? new RowSezione("Esiti",esiti) : new RowSezione(null, null),
          udienzeEsiti.length > 0 ? new RowSezione("Udienze",udienzeEsiti) : new RowSezione(null,null),
          new RowSezione('Prossima udienza', [
            // new VoceSezione(4, 'date', 'Ultima udienza', fascicolo.copertina.campi.ultimaUdienza),
            new VoceSezione(6, 'text', 'Adempimento', fascicolo.copertina.campi.prossimaUdienzaTipoAdempimento),
            new VoceSezione(6, 'date', 'Prossima udienza', fascicolo.copertina.campi.prossimaUdienza),
            // new VoceSezione(4, 'date', 'Prossima scadenza', fascicolo.copertina.campi.prossimaScadenza)
          ]),
          new RowSezione('Competenze ', [
            new VoceSezione(12, 'text', 'Gruppi competenti', fascicolo.copertina.campi.competenza)
          ]),
        ];
        break;
      }
      case 'ricorsoamministrativo':
      case 'ricorsotar': {
        return [new RowSezione(null, [
          new VoceSezione(3, 'text', 'Posizione', fascicolo.copertina.campi.identificativoFascicolo),
          new VoceSezione(3, 'text', 'Vecchia posizione', fascicolo.vecchiaPosizione),
          new VoceSezione(3, 'text', 'Tipo Fascicolo', fascicolo.copertina.campi.tipo),
          new VoceSezione(3, 'text', 'Natura', fascicolo.copertina.campi.natura)
        ]),
          new RowSezione(null, [
            new VoceSezione(12, 'textarea', 'Descrizione oggetto', fascicolo.descrizioneOggetto),
          ]),
          new RowSezione(null, [
            new VoceSezione(4, 'date', 'Data apertura fascicolo', fascicolo.copertina.campi.dataInizioFascicolo),
            new VoceSezione(4, 'date', 'Data ultima modifica', fascicolo.copertina.campi.dataUltimaModifica),
            new VoceSezione(4, 'text', 'Stato', fascicolo.copertina.campi.stato)
          ]),
          new RowSezione(null, [
            new VoceSezione(6, 'date', 'Data definizione', fascicolo.copertina.campi.dataDefinizione),
            new VoceSezione(6, 'text', 'Motivo definizione', fascicolo.copertina.campi.motivoDefinizione),
            //new VoceSezione(4, 'boolean', 'Fondo rischi', fascicolo.copertina.campi.fondoRischi)
          ]),
          new RowSezione(((fascicolo.copertina.campi.capofila || fascicolo.copertina.campi.riunito) ? 'Riunione dei giudizi' : ''), (fascicolo.copertina.campi.capofila || fascicolo.copertina.campi.riunito) ? [
            new VoceSezione(4, 'text', fascicolo.copertina.campi.capofila ? 'Capofila' : 'Riunito', 'Si'),
            new VoceSezione(4, 'date', 'Data riunione giudizio', fascicolo.copertina.campi.dataRiunioneGiudizio),
            new VoceSezione(4, 'text', 'Motivo riunione giudizio', fascicolo.copertina.campi.motivoRiunioneGiudizio)
          ] : [new VoceSezione(12, '', '', '')]),
          new RowSezione(null, [
            new VoceSezione(4, 'text', 'Parte primaria (n. controparti)', (fascicolo.copertina.campi.contropartePrimaria) + (' (' + fascicolo.copertina.campi.numeroControparti + ')')),
            //new VoceSezione(4, 'text', 'Legale incaricato', (fascicolo.copertina.campi.legaleIncaricato ? fascicolo.copertina.campi.legaleIncaricato : '') + (fascicolo.copertina.campi.tipologiaDiLegaleIncaricato ? ' (' + fascicolo.copertina.campi.tipologiaDiLegaleIncaricato + ')' : '')),
            new VoceSezione(4, 'text', 'Assegnatario', assegnatario),
            new VoceSezione(4, 'text', 'Visibilità', fascicolo.tipoVisibilita?.label ? fascicolo.tipoVisibilita?.label : (fascicolo.praticaBase.tipoVisibilita?.label ? fascicolo.praticaBase.tipoVisibilita?.label : null))
          ]),
          new RowSezione(null, [
            new VoceSezione(4, 'text', 'Numero/anno ruolo', (fascicolo.copertina.campi.numeroRuolo ? fascicolo.copertina.campi.numeroRuolo : '') + (fascicolo.copertina.campi.numeroRuolo && fascicolo.copertina.campi.annoRuolo ? '/' : '') + (fascicolo.copertina.campi.annoRuolo ? fascicolo.copertina.campi.annoRuolo : '')),
            new VoceSezione(4, 'text', 'Autorit&agrave; giudiziaria', (fascicolo.copertina.campi.autoritaGiudiziaria ? fascicolo.copertina.campi.autoritaGiudiziaria : '') + (fascicolo.copertina.campi.sedeAutoritaGiudiziaria != null ? ' di ' + (fascicolo.copertina.campi.sedeAutoritaGiudiziaria) : '')),
            new VoceSezione(4, 'text', 'Valore', fascicolo.copertina.campi.valore)
          ]),
          esiti.length > 0 ? new RowSezione("Esiti",esiti) : new RowSezione(null, null),
          udienzeEsiti.length > 0 ? new RowSezione("Udienze",udienzeEsiti) : new RowSezione(null,null),
          new RowSezione('Prossima udienza', [
            // new VoceSezione(4, 'date', 'Ultima udienza', fascicolo.copertina.campi.ultimaUdienza),
            new VoceSezione(6, 'text', 'Adempimento', fascicolo.copertina.campi.prossimaUdienzaTipoAdempimento),
            new VoceSezione(6, 'date', 'Prossima udienza', fascicolo.copertina.campi.prossimaUdienza),
            // new VoceSezione(4, 'date', 'Prossima scadenza', fascicolo.copertina.campi.prossimaScadenza)
          ]),
          new RowSezione('Competenze ', [
            new VoceSezione(12, 'text', 'Gruppi competenti', fascicolo.copertina.campi.competenza)
          ]),
        ];
        break;
      }
      case 'ricorsoamministrativo':
      case 'ricorsotar': {
        return [new RowSezione(null, [
          new VoceSezione(3, 'text', 'Posizione', fascicolo.copertina.campi.identificativoFascicolo),
          new VoceSezione(3, 'text', 'Vecchia posizione', fascicolo.vecchiaPosizione),
          new VoceSezione(3, 'text', 'Tipo Fascicolo', fascicolo.copertina.campi.tipo),
          new VoceSezione(3, 'text', 'Natura', fascicolo.copertina.campi.natura)
        ]),
          new RowSezione(null, [
            new VoceSezione(12, 'textarea', 'Descrizione oggetto', fascicolo.descrizioneOggetto),
          ]),
          new RowSezione(null, [
            new VoceSezione(4, 'date', 'Data apertura fascicolo', fascicolo.copertina.campi.dataInizioFascicolo),
            new VoceSezione(4, 'date', 'Data ultima modifica', fascicolo.copertina.campi.dataUltimaModifica),
            new VoceSezione(4, 'text', 'Stato', fascicolo.copertina.campi.stato)
          ]),
          new RowSezione(null, [
            new VoceSezione(6, 'date', 'Data definizione', fascicolo.copertina.campi.dataDefinizione),
            new VoceSezione(6, 'text', 'Motivo definizione', fascicolo.copertina.campi.motivoDefinizione),
            //new VoceSezione(4, 'boolean', 'Fondo rischi', fascicolo.copertina.campi.fondoRischi)
          ]),
          new RowSezione(((fascicolo.copertina.campi.capofila || fascicolo.copertina.campi.riunito) ? 'Riunione dei giudizi' : ''), (fascicolo.copertina.campi.capofila || fascicolo.copertina.campi.riunito) ? [
            new VoceSezione(4, 'text', fascicolo.copertina.campi.capofila ? 'Capofila' : 'Riunito', 'Si'),
            new VoceSezione(4, 'date', 'Data riunione giudizio', fascicolo.copertina.campi.dataRiunioneGiudizio),
            new VoceSezione(4, 'text', 'Motivo riunione giudizio', fascicolo.copertina.campi.motivoRiunioneGiudizio)
          ] : [new VoceSezione(12, '', '', '')]),
          new RowSezione(null, [
            new VoceSezione(4, 'text', 'Parte primaria (n. controparti)', (fascicolo.copertina.campi.contropartePrimaria) + (' (' + fascicolo.copertina.campi.numeroControparti + ')')),
            //new VoceSezione(4, 'text', 'Legale incaricato', (fascicolo.copertina.campi.legaleIncaricato ? fascicolo.copertina.campi.legaleIncaricato : '') + (fascicolo.copertina.campi.tipologiaDiLegaleIncaricato ? ' (' + fascicolo.copertina.campi.tipologiaDiLegaleIncaricato + ')' : '')),
            new VoceSezione(4, 'text', 'Assegnatario', assegnatario),
            new VoceSezione(4, 'text', 'Visibilità', fascicolo.tipoVisibilita?.label ? fascicolo.tipoVisibilita?.label : (fascicolo.praticaBase.tipoVisibilita?.label ? fascicolo.praticaBase.tipoVisibilita?.label : null))
          ]),
          new RowSezione(null, [
            new VoceSezione(4, 'text', 'Numero/anno ruolo', (fascicolo.copertina.campi.numeroRuolo ? fascicolo.copertina.campi.numeroRuolo : '') + (fascicolo.copertina.campi.numeroRuolo && fascicolo.copertina.campi.annoRuolo ? '/' : '') + (fascicolo.copertina.campi.annoRuolo ? fascicolo.copertina.campi.annoRuolo : '')),
            new VoceSezione(4, 'text', 'Autorit&agrave; giudiziaria', (fascicolo.copertina.campi.autoritaGiudiziaria ? fascicolo.copertina.campi.autoritaGiudiziaria : '') + (fascicolo.copertina.campi.sedeAutoritaGiudiziaria != null ? ' di ' + (fascicolo.copertina.campi.sedeAutoritaGiudiziaria) : '')),
            new VoceSezione(4, 'text', 'Valore', fascicolo.copertina.campi.valore)
          ]),
          esiti.length > 0 ? new RowSezione("Esiti",esiti) : new RowSezione(null, null),
          udienzeEsiti.length > 0 ? new RowSezione("Udienze",udienzeEsiti) : new RowSezione(null,null),
          new RowSezione('Prossima udienza', [
            // new VoceSezione(4, 'date', 'Ultima udienza', fascicolo.copertina.campi.ultimaUdienza),
            new VoceSezione(6, 'text', 'Adempimento', fascicolo.copertina.campi.prossimaUdienzaTipoAdempimento),
            new VoceSezione(6, 'date', 'Prossima udienza', fascicolo.copertina.campi.prossimaUdienza),
            // new VoceSezione(4, 'date', 'Prossima scadenza', fascicolo.copertina.campi.prossimaScadenza)
          ]),
          new RowSezione('Competenze ', [
            new VoceSezione(12, 'text', 'Gruppi competenti', fascicolo.copertina.campi.competenza)
          ]),
        ];
        break;
      }
    }
  }

  getEsitiFromCopertina(fascicolo: FascicoloFull): any[]{
    let listaVoci = [];
    if (fascicolo.copertina.campi.esiti) {
      for (let esito of fascicolo.copertina.campi.esiti) {
        listaVoci.push(new VoceSezione(3, "text", "Esito", esito.esitoPerSocieta));
        listaVoci.push(new VoceSezione(3, "text", "Tipo", esito.tipoSentenza));
        listaVoci.push(new VoceSezione(3, "text", "Numero/Anno", esito.numeroSentenza));
        listaVoci.push(new VoceSezione(3, "text", "Risoluzione per parte", esito.esitoRisoluzioneParte));
      }
    }
    return listaVoci;
  }

  getUdienzeEsitiFromCopertina(fascicolo: FascicoloFull): any[] {
    let listaVoci = [];
    if (fascicolo.copertina.campi.scadenze) {
      for (let i = 0; i < fascicolo.copertina.campi.scadenze.length; i++) {
        let esitoUdienza = fascicolo.copertina.campi.scadenze[i];
    
        listaVoci.push(new VoceSezione(4, "text", "Adempimento", esitoUdienza.tipoAdempimento ?? ""));
        listaVoci.push(new VoceSezione(4, "date", "Data udienza", esitoUdienza.dataUdienza ?? ""));
        listaVoci.push(new VoceSezione(4, "text", "Tipo provvedimento", esitoUdienza.tipoEsito ?? ""));
        listaVoci.push(new VoceSezione(4, "text", "Numero/Anno esito", esitoUdienza.numeroAnnoEsito ?? ""));
        listaVoci.push(new VoceSezione(4, "date", "Data pubblicazione", esitoUdienza.dataPubblicazione ?? ""));
        listaVoci.push(new VoceSezione(4, "text", "Esito", esitoUdienza.esito ?? ""));
        listaVoci.push(new VoceSezione(12, "text", "Note udienza", esitoUdienza.noteUdienza ?? ""));    
        // Aggiungi il divider solo se ci sono almeno due elementi e NON per l'ultima iterazione
        if (fascicolo.copertina.campi.scadenze.length > 1 && i < fascicolo.copertina.campi.scadenze.length - 1) {
          listaVoci.push(new VoceSezione(12, "divider", "", ""));
        }
      }
    }
     
    return listaVoci;
  }
}
